import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import * as ApolloCore from '@apollo/client/core';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  float8: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
  vector: { input: any; output: any; }
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export interface Boolean_Comparison_Exp {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export interface Int_Array_Comparison_Exp {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Int']['input']>>;
  _eq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _lte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _neq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export interface Int_Comparison_Exp {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export interface String_Comparison_Exp {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
}

/** append existing jsonb value of filtered columns with new jsonb value */
export interface Ai_Models_Append_Input {
  additional_config?: InputMaybe<Scalars['jsonb']['input']>;
}

/** Boolean expression to filter rows from the table "ai_models". All fields are combined with a logical 'AND'. */
export interface Ai_Models_Bool_Exp {
  _and?: InputMaybe<Array<Ai_Models_Bool_Exp>>;
  _not?: InputMaybe<Ai_Models_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Models_Bool_Exp>>;
  additional_config?: InputMaybe<Jsonb_Comparison_Exp>;
  api_key?: InputMaybe<String_Comparison_Exp>;
  context_length?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  huggingface_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  model_usage_count?: InputMaybe<Int_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  type_label?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
}

/** unique or primary key constraints on table "ai_models" */
export enum Ai_Models_Constraint {
  /** unique or primary key constraint on columns "id" */
  AiModelsPkey = 'ai_models_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export interface Ai_Models_Delete_At_Path_Input {
  additional_config?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export interface Ai_Models_Delete_Elem_Input {
  additional_config?: InputMaybe<Scalars['Int']['input']>;
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export interface Ai_Models_Delete_Key_Input {
  additional_config?: InputMaybe<Scalars['String']['input']>;
}

/** input type for incrementing numeric columns in table "ai_models" */
export interface Ai_Models_Inc_Input {
  context_length?: InputMaybe<Scalars['Int']['input']>;
}

/** input type for inserting data into table "ai_models" */
export interface Ai_Models_Insert_Input {
  additional_config?: InputMaybe<Scalars['jsonb']['input']>;
  api_key?: InputMaybe<Scalars['String']['input']>;
  context_length?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  huggingface_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
}

/** input type for inserting object relation for remote table "ai_models" */
export interface Ai_Models_Obj_Rel_Insert_Input {
  data: Ai_Models_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ai_Models_On_Conflict>;
}

/** on_conflict condition type for table "ai_models" */
export interface Ai_Models_On_Conflict {
  constraint: Ai_Models_Constraint;
  update_columns?: Array<Ai_Models_Update_Column>;
  where?: InputMaybe<Ai_Models_Bool_Exp>;
}

/** Ordering options when selecting data from "ai_models". */
export interface Ai_Models_Order_By {
  additional_config?: InputMaybe<Order_By>;
  api_key?: InputMaybe<Order_By>;
  context_length?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  huggingface_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  model_usage_count?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  type_label?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
}

/** primary key columns input for table: ai_models */
export interface Ai_Models_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export interface Ai_Models_Prepend_Input {
  additional_config?: InputMaybe<Scalars['jsonb']['input']>;
}

/** select columns of table "ai_models" */
export enum Ai_Models_Select_Column {
  /** column name */
  AdditionalConfig = 'additional_config',
  /** column name */
  ApiKey = 'api_key',
  /** column name */
  ContextLength = 'context_length',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  HuggingfaceId = 'huggingface_id',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model',
  /** column name */
  Provider = 'provider',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "ai_models" */
export interface Ai_Models_Set_Input {
  additional_config?: InputMaybe<Scalars['jsonb']['input']>;
  api_key?: InputMaybe<Scalars['String']['input']>;
  context_length?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  huggingface_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
}

/** Streaming cursor of the table "ai_models" */
export interface Ai_Models_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Ai_Models_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Ai_Models_Stream_Cursor_Value_Input {
  additional_config?: InputMaybe<Scalars['jsonb']['input']>;
  api_key?: InputMaybe<Scalars['String']['input']>;
  context_length?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  huggingface_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
}

/** update columns of table "ai_models" */
export enum Ai_Models_Update_Column {
  /** column name */
  AdditionalConfig = 'additional_config',
  /** column name */
  ApiKey = 'api_key',
  /** column name */
  ContextLength = 'context_length',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  HuggingfaceId = 'huggingface_id',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model',
  /** column name */
  Provider = 'provider',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  Url = 'url'
}

export interface Ai_Models_Updates {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ai_Models_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ai_Models_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ai_Models_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ai_Models_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ai_Models_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ai_Models_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ai_Models_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ai_Models_Bool_Exp;
}

/** Boolean expression to filter rows from the table "chats". All fields are combined with a logical 'AND'. */
export interface Chats_Bool_Exp {
  Collection?: InputMaybe<Collections_Bool_Exp>;
  CreatedBy?: InputMaybe<Users_Bool_Exp>;
  Messages?: InputMaybe<Messages_Bool_Exp>;
  Messages_aggregate?: InputMaybe<Messages_Aggregate_Bool_Exp>;
  Organization?: InputMaybe<Organizations_Bool_Exp>;
  _and?: InputMaybe<Array<Chats_Bool_Exp>>;
  _not?: InputMaybe<Chats_Bool_Exp>;
  _or?: InputMaybe<Array<Chats_Bool_Exp>>;
  collection_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "chats" */
export enum Chats_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatsPkey = 'chats_pkey'
}

/** input type for inserting data into table "chats" */
export interface Chats_Insert_Input {
  Collection?: InputMaybe<Collections_Obj_Rel_Insert_Input>;
  CreatedBy?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  Messages?: InputMaybe<Messages_Arr_Rel_Insert_Input>;
  Organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** input type for inserting object relation for remote table "chats" */
export interface Chats_Obj_Rel_Insert_Input {
  data: Chats_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Chats_On_Conflict>;
}

/** on_conflict condition type for table "chats" */
export interface Chats_On_Conflict {
  constraint: Chats_Constraint;
  update_columns?: Array<Chats_Update_Column>;
  where?: InputMaybe<Chats_Bool_Exp>;
}

/** Ordering options when selecting data from "chats". */
export interface Chats_Order_By {
  Collection?: InputMaybe<Collections_Order_By>;
  CreatedBy?: InputMaybe<Users_Order_By>;
  Messages_aggregate?: InputMaybe<Messages_Aggregate_Order_By>;
  Organization?: InputMaybe<Organizations_Order_By>;
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: chats */
export interface Chats_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "chats" */
export enum Chats_Select_Column {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "chats" */
export interface Chats_Set_Input {
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "chats" */
export interface Chats_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Chats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Chats_Stream_Cursor_Value_Input {
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "chats" */
export enum Chats_Update_Column {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export interface Chats_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chats_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chats_Bool_Exp;
}

export interface Chunks_Aggregate_Bool_Exp {
  count?: InputMaybe<Chunks_Aggregate_Bool_Exp_Count>;
}

export interface Chunks_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Chunks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chunks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** order by aggregate values of table "chunks" */
export interface Chunks_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chunks_Max_Order_By>;
  min?: InputMaybe<Chunks_Min_Order_By>;
}

/** input type for inserting array relation for remote table "chunks" */
export interface Chunks_Arr_Rel_Insert_Input {
  data: Array<Chunks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Chunks_On_Conflict>;
}

/** Boolean expression to filter rows from the table "chunks". All fields are combined with a logical 'AND'. */
export interface Chunks_Bool_Exp {
  Collection?: InputMaybe<Collections_Bool_Exp>;
  Document?: InputMaybe<Documents_Bool_Exp>;
  Sources?: InputMaybe<Message_Sources_Bool_Exp>;
  Sources_aggregate?: InputMaybe<Message_Sources_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<Chunks_Bool_Exp>>;
  _not?: InputMaybe<Chunks_Bool_Exp>;
  _or?: InputMaybe<Array<Chunks_Bool_Exp>>;
  collection_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  pages?: InputMaybe<Int_Array_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
}

/** unique or primary key constraints on table "chunks" */
export enum Chunks_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChunksPkey = 'chunks_pkey'
}

/** input type for inserting data into table "chunks" */
export interface Chunks_Insert_Input {
  Collection?: InputMaybe<Collections_Obj_Rel_Insert_Input>;
  Document?: InputMaybe<Documents_Obj_Rel_Insert_Input>;
  Sources?: InputMaybe<Message_Sources_Arr_Rel_Insert_Input>;
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pages?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
}

/** order by max() on columns of table "chunks" */
export interface Chunks_Max_Order_By {
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pages?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
}

/** order by min() on columns of table "chunks" */
export interface Chunks_Min_Order_By {
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pages?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
}

/** input type for inserting object relation for remote table "chunks" */
export interface Chunks_Obj_Rel_Insert_Input {
  data: Chunks_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Chunks_On_Conflict>;
}

/** on_conflict condition type for table "chunks" */
export interface Chunks_On_Conflict {
  constraint: Chunks_Constraint;
  update_columns?: Array<Chunks_Update_Column>;
  where?: InputMaybe<Chunks_Bool_Exp>;
}

/** Ordering options when selecting data from "chunks". */
export interface Chunks_Order_By {
  Collection?: InputMaybe<Collections_Order_By>;
  Document?: InputMaybe<Documents_Order_By>;
  Sources_aggregate?: InputMaybe<Message_Sources_Aggregate_Order_By>;
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pages?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
}

/** primary key columns input for table: chunks */
export interface Chunks_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "chunks" */
export enum Chunks_Select_Column {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Id = 'id',
  /** column name */
  Pages = 'pages',
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "chunks" */
export interface Chunks_Set_Input {
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pages?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
}

/** Streaming cursor of the table "chunks" */
export interface Chunks_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Chunks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Chunks_Stream_Cursor_Value_Input {
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  pages?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
}

/** update columns of table "chunks" */
export enum Chunks_Update_Column {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Id = 'id',
  /** column name */
  Pages = 'pages',
  /** column name */
  Text = 'text'
}

export interface Chunks_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chunks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chunks_Bool_Exp;
}

/** Boolean expression to filter rows from the table "collections". All fields are combined with a logical 'AND'. */
export interface Collections_Bool_Exp {
  Chunks?: InputMaybe<Chunks_Bool_Exp>;
  Chunks_aggregate?: InputMaybe<Chunks_Aggregate_Bool_Exp>;
  Documents?: InputMaybe<Documents_Bool_Exp>;
  Documents_aggregate?: InputMaybe<Documents_Aggregate_Bool_Exp>;
  Organization?: InputMaybe<Organizations_Bool_Exp>;
  _and?: InputMaybe<Array<Collections_Bool_Exp>>;
  _not?: InputMaybe<Collections_Bool_Exp>;
  _or?: InputMaybe<Array<Collections_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  llm_temperature?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  private?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  system_prompt?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_prompt_template?: InputMaybe<String_Comparison_Exp>;
}

/** unique or primary key constraints on table "collections" */
export enum Collections_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollectionsPkey = 'collections_pkey'
}

/** input type for incrementing numeric columns in table "collections" */
export interface Collections_Inc_Input {
  llm_temperature?: InputMaybe<Scalars['numeric']['input']>;
}

/** input type for inserting data into table "collections" */
export interface Collections_Insert_Input {
  Chunks?: InputMaybe<Chunks_Arr_Rel_Insert_Input>;
  Documents?: InputMaybe<Documents_Arr_Rel_Insert_Input>;
  Organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  llm_temperature?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  system_prompt?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
  user_prompt_template?: InputMaybe<Scalars['String']['input']>;
}

/** input type for inserting object relation for remote table "collections" */
export interface Collections_Obj_Rel_Insert_Input {
  data: Collections_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Collections_On_Conflict>;
}

/** on_conflict condition type for table "collections" */
export interface Collections_On_Conflict {
  constraint: Collections_Constraint;
  update_columns?: Array<Collections_Update_Column>;
  where?: InputMaybe<Collections_Bool_Exp>;
}

/** Ordering options when selecting data from "collections". */
export interface Collections_Order_By {
  Chunks_aggregate?: InputMaybe<Chunks_Aggregate_Order_By>;
  Documents_aggregate?: InputMaybe<Documents_Aggregate_Order_By>;
  Organization?: InputMaybe<Organizations_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llm_temperature?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  private?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  system_prompt?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
  user_prompt_template?: InputMaybe<Order_By>;
}

/** primary key columns input for table: collections */
export interface Collections_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "collections" */
export enum Collections_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LlmTemperature = 'llm_temperature',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Private = 'private',
  /** column name */
  SystemPrompt = 'system_prompt',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserPromptTemplate = 'user_prompt_template'
}

/** input type for updating data in table "collections" */
export interface Collections_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  llm_temperature?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  system_prompt?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
  user_prompt_template?: InputMaybe<Scalars['String']['input']>;
}

/** Streaming cursor of the table "collections" */
export interface Collections_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Collections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Collections_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  llm_temperature?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  system_prompt?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
  user_prompt_template?: InputMaybe<Scalars['String']['input']>;
}

/** update columns of table "collections" */
export enum Collections_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LlmTemperature = 'llm_temperature',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Private = 'private',
  /** column name */
  SystemPrompt = 'system_prompt',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserPromptTemplate = 'user_prompt_template'
}

export interface Collections_Updates {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Collections_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Collections_Set_Input>;
  /** filter the rows which have to be updated */
  where: Collections_Bool_Exp;
}

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

export interface Documents_Aggregate_Bool_Exp {
  count?: InputMaybe<Documents_Aggregate_Bool_Exp_Count>;
}

export interface Documents_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** order by aggregate values of table "documents" */
export interface Documents_Aggregate_Order_By {
  avg?: InputMaybe<Documents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Documents_Max_Order_By>;
  min?: InputMaybe<Documents_Min_Order_By>;
  stddev?: InputMaybe<Documents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Documents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Documents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Documents_Sum_Order_By>;
  var_pop?: InputMaybe<Documents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Documents_Var_Samp_Order_By>;
  variance?: InputMaybe<Documents_Variance_Order_By>;
}

/** input type for inserting array relation for remote table "documents" */
export interface Documents_Arr_Rel_Insert_Input {
  data: Array<Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Documents_On_Conflict>;
}

/** order by avg() on columns of table "documents" */
export interface Documents_Avg_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** Boolean expression to filter rows from the table "documents". All fields are combined with a logical 'AND'. */
export interface Documents_Bool_Exp {
  Collection?: InputMaybe<Collections_Bool_Exp>;
  File?: InputMaybe<Files_Bool_Exp>;
  _and?: InputMaybe<Array<Documents_Bool_Exp>>;
  _not?: InputMaybe<Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Documents_Bool_Exp>>;
  collection_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  processing_time?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
}

/** unique or primary key constraints on table "documents" */
export enum Documents_Constraint {
  /** unique or primary key constraint on columns "file_id" */
  DocumentsFileIdKey = 'documents_file_id_key',
  /** unique or primary key constraint on columns "id" */
  DocumentsPkey = 'documents_pkey'
}

/** input type for incrementing numeric columns in table "documents" */
export interface Documents_Inc_Input {
  processing_time?: InputMaybe<Scalars['numeric']['input']>;
}

/** input type for inserting data into table "documents" */
export interface Documents_Insert_Input {
  Collection?: InputMaybe<Collections_Obj_Rel_Insert_Input>;
  File?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  processing_time?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** order by max() on columns of table "documents" */
export interface Documents_Max_Order_By {
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  processing_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** order by min() on columns of table "documents" */
export interface Documents_Min_Order_By {
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  processing_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** input type for inserting object relation for remote table "documents" */
export interface Documents_Obj_Rel_Insert_Input {
  data: Documents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Documents_On_Conflict>;
}

/** on_conflict condition type for table "documents" */
export interface Documents_On_Conflict {
  constraint: Documents_Constraint;
  update_columns?: Array<Documents_Update_Column>;
  where?: InputMaybe<Documents_Bool_Exp>;
}

/** Ordering options when selecting data from "documents". */
export interface Documents_Order_By {
  Collection?: InputMaybe<Collections_Order_By>;
  File?: InputMaybe<Files_Order_By>;
  collection_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  processing_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** primary key columns input for table: documents */
export interface Documents_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "documents" */
export enum Documents_Select_Column {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProcessingTime = 'processing_time',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "documents" */
export interface Documents_Set_Input {
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  processing_time?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** order by stddev() on columns of table "documents" */
export interface Documents_Stddev_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** order by stddev_pop() on columns of table "documents" */
export interface Documents_Stddev_Pop_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** order by stddev_samp() on columns of table "documents" */
export interface Documents_Stddev_Samp_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** Streaming cursor of the table "documents" */
export interface Documents_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Documents_Stream_Cursor_Value_Input {
  collection_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  processing_time?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** order by sum() on columns of table "documents" */
export interface Documents_Sum_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** update columns of table "documents" */
export enum Documents_Update_Column {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProcessingTime = 'processing_time',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export interface Documents_Updates {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Documents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Documents_Bool_Exp;
}

/** order by var_pop() on columns of table "documents" */
export interface Documents_Var_Pop_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** order by var_samp() on columns of table "documents" */
export interface Documents_Var_Samp_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** order by variance() on columns of table "documents" */
export interface Documents_Variance_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export interface Files_Bool_Exp {
  CreatedBy?: InputMaybe<Users_Bool_Exp>;
  Document?: InputMaybe<Documents_Bool_Exp>;
  MessageAttachment?: InputMaybe<Message_Attachments_Bool_Exp>;
  Organization?: InputMaybe<Organizations_Bool_Exp>;
  OrganizationFavicon?: InputMaybe<Organizations_Bool_Exp>;
  OrganizationLogo?: InputMaybe<Organizations_Bool_Exp>;
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
}

/** unique or primary key constraints on table "files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** input type for incrementing numeric columns in table "files" */
export interface Files_Inc_Input {
  size?: InputMaybe<Scalars['Int']['input']>;
}

/** input type for inserting data into table "files" */
export interface Files_Insert_Input {
  CreatedBy?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  Document?: InputMaybe<Documents_Obj_Rel_Insert_Input>;
  MessageAttachment?: InputMaybe<Message_Attachments_Obj_Rel_Insert_Input>;
  Organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  OrganizationFavicon?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  OrganizationLogo?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}

/** input type for inserting object relation for remote table "files" */
export interface Files_Obj_Rel_Insert_Input {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
}

/** on_conflict condition type for table "files" */
export interface Files_On_Conflict {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
}

/** Ordering options when selecting data from "files". */
export interface Files_Order_By {
  CreatedBy?: InputMaybe<Users_Order_By>;
  Document?: InputMaybe<Documents_Order_By>;
  MessageAttachment?: InputMaybe<Message_Attachments_Order_By>;
  Organization?: InputMaybe<Organizations_Order_By>;
  OrganizationFavicon?: InputMaybe<Organizations_Order_By>;
  OrganizationLogo?: InputMaybe<Organizations_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
}

/** primary key columns input for table: files */
export interface Files_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "files" */
export enum Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Size = 'size'
}

/** input type for updating data in table "files" */
export interface Files_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}

/** Streaming cursor of the table "files" */
export interface Files_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Files_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}

/** update columns of table "files" */
export enum Files_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Size = 'size'
}

export interface Files_Updates {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
}

export interface Find_Similar_Chunks_Args {
  input_collection_id?: InputMaybe<Scalars['uuid']['input']>;
  input_embedding?: InputMaybe<Scalars['vector']['input']>;
  input_limit?: InputMaybe<Scalars['Int']['input']>;
}

/** Boolean expression to filter rows from the table "find_similar_chunks_result_format". All fields are combined with a logical 'AND'. */
export interface Find_Similar_Chunks_Result_Format_Bool_Exp {
  _and?: InputMaybe<Array<Find_Similar_Chunks_Result_Format_Bool_Exp>>;
  _not?: InputMaybe<Find_Similar_Chunks_Result_Format_Bool_Exp>;
  _or?: InputMaybe<Array<Find_Similar_Chunks_Result_Format_Bool_Exp>>;
  chunk_id?: InputMaybe<Uuid_Comparison_Exp>;
  chunk_pages?: InputMaybe<Int_Array_Comparison_Exp>;
  chunk_text?: InputMaybe<String_Comparison_Exp>;
  cosine_similarity?: InputMaybe<Float8_Comparison_Exp>;
  document_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_name?: InputMaybe<String_Comparison_Exp>;
}

/** input type for incrementing numeric columns in table "find_similar_chunks_result_format" */
export interface Find_Similar_Chunks_Result_Format_Inc_Input {
  cosine_similarity?: InputMaybe<Scalars['float8']['input']>;
}

/** input type for inserting data into table "find_similar_chunks_result_format" */
export interface Find_Similar_Chunks_Result_Format_Insert_Input {
  chunk_id?: InputMaybe<Scalars['uuid']['input']>;
  chunk_pages?: InputMaybe<Array<Scalars['Int']['input']>>;
  chunk_text?: InputMaybe<Scalars['String']['input']>;
  cosine_similarity?: InputMaybe<Scalars['float8']['input']>;
  document_file_id?: InputMaybe<Scalars['uuid']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  document_name?: InputMaybe<Scalars['String']['input']>;
}

/** Ordering options when selecting data from "find_similar_chunks_result_format". */
export interface Find_Similar_Chunks_Result_Format_Order_By {
  chunk_id?: InputMaybe<Order_By>;
  chunk_pages?: InputMaybe<Order_By>;
  chunk_text?: InputMaybe<Order_By>;
  cosine_similarity?: InputMaybe<Order_By>;
  document_file_id?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
}

/** select columns of table "find_similar_chunks_result_format" */
export enum Find_Similar_Chunks_Result_Format_Select_Column {
  /** column name */
  ChunkId = 'chunk_id',
  /** column name */
  ChunkPages = 'chunk_pages',
  /** column name */
  ChunkText = 'chunk_text',
  /** column name */
  CosineSimilarity = 'cosine_similarity',
  /** column name */
  DocumentFileId = 'document_file_id',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  DocumentName = 'document_name'
}

/** input type for updating data in table "find_similar_chunks_result_format" */
export interface Find_Similar_Chunks_Result_Format_Set_Input {
  chunk_id?: InputMaybe<Scalars['uuid']['input']>;
  chunk_pages?: InputMaybe<Array<Scalars['Int']['input']>>;
  chunk_text?: InputMaybe<Scalars['String']['input']>;
  cosine_similarity?: InputMaybe<Scalars['float8']['input']>;
  document_file_id?: InputMaybe<Scalars['uuid']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  document_name?: InputMaybe<Scalars['String']['input']>;
}

/** Streaming cursor of the table "find_similar_chunks_result_format" */
export interface Find_Similar_Chunks_Result_Format_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Find_Similar_Chunks_Result_Format_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Find_Similar_Chunks_Result_Format_Stream_Cursor_Value_Input {
  chunk_id?: InputMaybe<Scalars['uuid']['input']>;
  chunk_pages?: InputMaybe<Array<Scalars['Int']['input']>>;
  chunk_text?: InputMaybe<Scalars['String']['input']>;
  cosine_similarity?: InputMaybe<Scalars['float8']['input']>;
  document_file_id?: InputMaybe<Scalars['uuid']['input']>;
  document_id?: InputMaybe<Scalars['uuid']['input']>;
  document_name?: InputMaybe<Scalars['String']['input']>;
}

export interface Find_Similar_Chunks_Result_Format_Updates {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Find_Similar_Chunks_Result_Format_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Find_Similar_Chunks_Result_Format_Set_Input>;
  /** filter the rows which have to be updated */
  where: Find_Similar_Chunks_Result_Format_Bool_Exp;
}

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export interface Float8_Comparison_Exp {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
}

/** Boolean expression to filter rows from the table "get_default_system_prompt_result_format". All fields are combined with a logical 'AND'. */
export interface Get_Default_System_Prompt_Result_Format_Bool_Exp {
  _and?: InputMaybe<Array<Get_Default_System_Prompt_Result_Format_Bool_Exp>>;
  _not?: InputMaybe<Get_Default_System_Prompt_Result_Format_Bool_Exp>;
  _or?: InputMaybe<Array<Get_Default_System_Prompt_Result_Format_Bool_Exp>>;
  system_prompt?: InputMaybe<String_Comparison_Exp>;
}

/** input type for inserting data into table "get_default_system_prompt_result_format" */
export interface Get_Default_System_Prompt_Result_Format_Insert_Input {
  system_prompt?: InputMaybe<Scalars['String']['input']>;
}

/** Ordering options when selecting data from "get_default_system_prompt_result_format". */
export interface Get_Default_System_Prompt_Result_Format_Order_By {
  system_prompt?: InputMaybe<Order_By>;
}

/** select columns of table "get_default_system_prompt_result_format" */
export enum Get_Default_System_Prompt_Result_Format_Select_Column {
  /** column name */
  SystemPrompt = 'system_prompt'
}

/** input type for updating data in table "get_default_system_prompt_result_format" */
export interface Get_Default_System_Prompt_Result_Format_Set_Input {
  system_prompt?: InputMaybe<Scalars['String']['input']>;
}

/** Streaming cursor of the table "get_default_system_prompt_result_format" */
export interface Get_Default_System_Prompt_Result_Format_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Get_Default_System_Prompt_Result_Format_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Get_Default_System_Prompt_Result_Format_Stream_Cursor_Value_Input {
  system_prompt?: InputMaybe<Scalars['String']['input']>;
}

export interface Get_Default_System_Prompt_Result_Format_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Get_Default_System_Prompt_Result_Format_Set_Input>;
  /** filter the rows which have to be updated */
  where: Get_Default_System_Prompt_Result_Format_Bool_Exp;
}

export interface Jsonb_Cast_Exp {
  String?: InputMaybe<String_Comparison_Exp>;
}

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export interface Jsonb_Comparison_Exp {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
}

export interface Message_Attachments_Aggregate_Bool_Exp {
  count?: InputMaybe<Message_Attachments_Aggregate_Bool_Exp_Count>;
}

export interface Message_Attachments_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Message_Attachments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Message_Attachments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** order by aggregate values of table "message_attachments" */
export interface Message_Attachments_Aggregate_Order_By {
  avg?: InputMaybe<Message_Attachments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Message_Attachments_Max_Order_By>;
  min?: InputMaybe<Message_Attachments_Min_Order_By>;
  stddev?: InputMaybe<Message_Attachments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Message_Attachments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Message_Attachments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Message_Attachments_Sum_Order_By>;
  var_pop?: InputMaybe<Message_Attachments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Message_Attachments_Var_Samp_Order_By>;
  variance?: InputMaybe<Message_Attachments_Variance_Order_By>;
}

/** input type for inserting array relation for remote table "message_attachments" */
export interface Message_Attachments_Arr_Rel_Insert_Input {
  data: Array<Message_Attachments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Message_Attachments_On_Conflict>;
}

/** order by avg() on columns of table "message_attachments" */
export interface Message_Attachments_Avg_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** Boolean expression to filter rows from the table "message_attachments". All fields are combined with a logical 'AND'. */
export interface Message_Attachments_Bool_Exp {
  File?: InputMaybe<Files_Bool_Exp>;
  Message?: InputMaybe<Messages_Bool_Exp>;
  User?: InputMaybe<Users_Bool_Exp>;
  _and?: InputMaybe<Array<Message_Attachments_Bool_Exp>>;
  _not?: InputMaybe<Message_Attachments_Bool_Exp>;
  _or?: InputMaybe<Array<Message_Attachments_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  full_text?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message_id?: InputMaybe<Uuid_Comparison_Exp>;
  processing_time?: InputMaybe<Numeric_Comparison_Exp>;
}

/** unique or primary key constraints on table "message_attachments" */
export enum Message_Attachments_Constraint {
  /** unique or primary key constraint on columns "file_id" */
  MessageAttachmentsFileIdKey = 'message_attachments_file_id_key',
  /** unique or primary key constraint on columns "id" */
  MessageAttachmentsPkey = 'message_attachments_pkey'
}

/** input type for incrementing numeric columns in table "message_attachments" */
export interface Message_Attachments_Inc_Input {
  processing_time?: InputMaybe<Scalars['numeric']['input']>;
}

/** input type for inserting data into table "message_attachments" */
export interface Message_Attachments_Insert_Input {
  File?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  Message?: InputMaybe<Messages_Obj_Rel_Insert_Input>;
  User?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  full_text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  processing_time?: InputMaybe<Scalars['numeric']['input']>;
}

/** order by max() on columns of table "message_attachments" */
export interface Message_Attachments_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  full_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  processing_time?: InputMaybe<Order_By>;
}

/** order by min() on columns of table "message_attachments" */
export interface Message_Attachments_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  full_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  processing_time?: InputMaybe<Order_By>;
}

/** input type for inserting object relation for remote table "message_attachments" */
export interface Message_Attachments_Obj_Rel_Insert_Input {
  data: Message_Attachments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Message_Attachments_On_Conflict>;
}

/** on_conflict condition type for table "message_attachments" */
export interface Message_Attachments_On_Conflict {
  constraint: Message_Attachments_Constraint;
  update_columns?: Array<Message_Attachments_Update_Column>;
  where?: InputMaybe<Message_Attachments_Bool_Exp>;
}

/** Ordering options when selecting data from "message_attachments". */
export interface Message_Attachments_Order_By {
  File?: InputMaybe<Files_Order_By>;
  Message?: InputMaybe<Messages_Order_By>;
  User?: InputMaybe<Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  full_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  processing_time?: InputMaybe<Order_By>;
}

/** primary key columns input for table: message_attachments */
export interface Message_Attachments_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "message_attachments" */
export enum Message_Attachments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  FullText = 'full_text',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  ProcessingTime = 'processing_time'
}

/** input type for updating data in table "message_attachments" */
export interface Message_Attachments_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  full_text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  processing_time?: InputMaybe<Scalars['numeric']['input']>;
}

/** order by stddev() on columns of table "message_attachments" */
export interface Message_Attachments_Stddev_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** order by stddev_pop() on columns of table "message_attachments" */
export interface Message_Attachments_Stddev_Pop_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** order by stddev_samp() on columns of table "message_attachments" */
export interface Message_Attachments_Stddev_Samp_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** Streaming cursor of the table "message_attachments" */
export interface Message_Attachments_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Message_Attachments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Message_Attachments_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  full_text?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  processing_time?: InputMaybe<Scalars['numeric']['input']>;
}

/** order by sum() on columns of table "message_attachments" */
export interface Message_Attachments_Sum_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** update columns of table "message_attachments" */
export enum Message_Attachments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  FullText = 'full_text',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  ProcessingTime = 'processing_time'
}

export interface Message_Attachments_Updates {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Message_Attachments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Message_Attachments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Message_Attachments_Bool_Exp;
}

/** order by var_pop() on columns of table "message_attachments" */
export interface Message_Attachments_Var_Pop_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** order by var_samp() on columns of table "message_attachments" */
export interface Message_Attachments_Var_Samp_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

/** order by variance() on columns of table "message_attachments" */
export interface Message_Attachments_Variance_Order_By {
  processing_time?: InputMaybe<Order_By>;
}

export interface Message_Sources_Aggregate_Bool_Exp {
  avg?: InputMaybe<Message_Sources_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Message_Sources_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Message_Sources_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Message_Sources_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Message_Sources_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Message_Sources_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Message_Sources_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Message_Sources_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Message_Sources_Aggregate_Bool_Exp_Var_Samp>;
}

export interface Message_Sources_Aggregate_Bool_Exp_Avg {
  arguments: Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Message_Sources_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
}

export interface Message_Sources_Aggregate_Bool_Exp_Corr {
  arguments: Message_Sources_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Message_Sources_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
}

export interface Message_Sources_Aggregate_Bool_Exp_Corr_Arguments {
  X: Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Corr_Arguments_Columns;
}

export interface Message_Sources_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Message_Sources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Message_Sources_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

export interface Message_Sources_Aggregate_Bool_Exp_Covar_Samp {
  arguments: Message_Sources_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Message_Sources_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
}

export interface Message_Sources_Aggregate_Bool_Exp_Covar_Samp_Arguments {
  X: Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
}

export interface Message_Sources_Aggregate_Bool_Exp_Max {
  arguments: Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Message_Sources_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
}

export interface Message_Sources_Aggregate_Bool_Exp_Min {
  arguments: Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Message_Sources_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
}

export interface Message_Sources_Aggregate_Bool_Exp_Stddev_Samp {
  arguments: Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Message_Sources_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
}

export interface Message_Sources_Aggregate_Bool_Exp_Sum {
  arguments: Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Message_Sources_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
}

export interface Message_Sources_Aggregate_Bool_Exp_Var_Samp {
  arguments: Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Message_Sources_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
}

/** order by aggregate values of table "message_sources" */
export interface Message_Sources_Aggregate_Order_By {
  avg?: InputMaybe<Message_Sources_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Message_Sources_Max_Order_By>;
  min?: InputMaybe<Message_Sources_Min_Order_By>;
  stddev?: InputMaybe<Message_Sources_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Message_Sources_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Message_Sources_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Message_Sources_Sum_Order_By>;
  var_pop?: InputMaybe<Message_Sources_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Message_Sources_Var_Samp_Order_By>;
  variance?: InputMaybe<Message_Sources_Variance_Order_By>;
}

/** input type for inserting array relation for remote table "message_sources" */
export interface Message_Sources_Arr_Rel_Insert_Input {
  data: Array<Message_Sources_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Message_Sources_On_Conflict>;
}

/** order by avg() on columns of table "message_sources" */
export interface Message_Sources_Avg_Order_By {
  cosine_similarity?: InputMaybe<Order_By>;
  reranker_score?: InputMaybe<Order_By>;
}

/** Boolean expression to filter rows from the table "message_sources". All fields are combined with a logical 'AND'. */
export interface Message_Sources_Bool_Exp {
  Chunk?: InputMaybe<Chunks_Bool_Exp>;
  Message?: InputMaybe<Messages_Bool_Exp>;
  _and?: InputMaybe<Array<Message_Sources_Bool_Exp>>;
  _not?: InputMaybe<Message_Sources_Bool_Exp>;
  _or?: InputMaybe<Array<Message_Sources_Bool_Exp>>;
  chunk_id?: InputMaybe<Uuid_Comparison_Exp>;
  cosine_similarity?: InputMaybe<Float8_Comparison_Exp>;
  message_id?: InputMaybe<Uuid_Comparison_Exp>;
  reranker_score?: InputMaybe<Float8_Comparison_Exp>;
}

/** unique or primary key constraints on table "message_sources" */
export enum Message_Sources_Constraint {
  /** unique or primary key constraint on columns "chunk_id", "message_id" */
  MessageSourcesPkey = 'message_sources_pkey'
}

/** input type for incrementing numeric columns in table "message_sources" */
export interface Message_Sources_Inc_Input {
  cosine_similarity?: InputMaybe<Scalars['float8']['input']>;
  reranker_score?: InputMaybe<Scalars['float8']['input']>;
}

/** input type for inserting data into table "message_sources" */
export interface Message_Sources_Insert_Input {
  Chunk?: InputMaybe<Chunks_Obj_Rel_Insert_Input>;
  Message?: InputMaybe<Messages_Obj_Rel_Insert_Input>;
  chunk_id?: InputMaybe<Scalars['uuid']['input']>;
  cosine_similarity?: InputMaybe<Scalars['float8']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  reranker_score?: InputMaybe<Scalars['float8']['input']>;
}

/** order by max() on columns of table "message_sources" */
export interface Message_Sources_Max_Order_By {
  chunk_id?: InputMaybe<Order_By>;
  cosine_similarity?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  reranker_score?: InputMaybe<Order_By>;
}

/** order by min() on columns of table "message_sources" */
export interface Message_Sources_Min_Order_By {
  chunk_id?: InputMaybe<Order_By>;
  cosine_similarity?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  reranker_score?: InputMaybe<Order_By>;
}

/** on_conflict condition type for table "message_sources" */
export interface Message_Sources_On_Conflict {
  constraint: Message_Sources_Constraint;
  update_columns?: Array<Message_Sources_Update_Column>;
  where?: InputMaybe<Message_Sources_Bool_Exp>;
}

/** Ordering options when selecting data from "message_sources". */
export interface Message_Sources_Order_By {
  Chunk?: InputMaybe<Chunks_Order_By>;
  Message?: InputMaybe<Messages_Order_By>;
  chunk_id?: InputMaybe<Order_By>;
  cosine_similarity?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  reranker_score?: InputMaybe<Order_By>;
}

/** primary key columns input for table: message_sources */
export interface Message_Sources_Pk_Columns_Input {
  chunk_id: Scalars['uuid']['input'];
  message_id: Scalars['uuid']['input'];
}

/** select columns of table "message_sources" */
export enum Message_Sources_Select_Column {
  /** column name */
  ChunkId = 'chunk_id',
  /** column name */
  CosineSimilarity = 'cosine_similarity',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  RerankerScore = 'reranker_score'
}

/** select "message_sources_aggregate_bool_exp_avg_arguments_columns" columns of table "message_sources" */
export enum Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  CosineSimilarity = 'cosine_similarity',
  /** column name */
  RerankerScore = 'reranker_score'
}

/** select "message_sources_aggregate_bool_exp_corr_arguments_columns" columns of table "message_sources" */
export enum Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  CosineSimilarity = 'cosine_similarity',
  /** column name */
  RerankerScore = 'reranker_score'
}

/** select "message_sources_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "message_sources" */
export enum Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  CosineSimilarity = 'cosine_similarity',
  /** column name */
  RerankerScore = 'reranker_score'
}

/** select "message_sources_aggregate_bool_exp_max_arguments_columns" columns of table "message_sources" */
export enum Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  CosineSimilarity = 'cosine_similarity',
  /** column name */
  RerankerScore = 'reranker_score'
}

/** select "message_sources_aggregate_bool_exp_min_arguments_columns" columns of table "message_sources" */
export enum Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  CosineSimilarity = 'cosine_similarity',
  /** column name */
  RerankerScore = 'reranker_score'
}

/** select "message_sources_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "message_sources" */
export enum Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  CosineSimilarity = 'cosine_similarity',
  /** column name */
  RerankerScore = 'reranker_score'
}

/** select "message_sources_aggregate_bool_exp_sum_arguments_columns" columns of table "message_sources" */
export enum Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  CosineSimilarity = 'cosine_similarity',
  /** column name */
  RerankerScore = 'reranker_score'
}

/** select "message_sources_aggregate_bool_exp_var_samp_arguments_columns" columns of table "message_sources" */
export enum Message_Sources_Select_Column_Message_Sources_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  CosineSimilarity = 'cosine_similarity',
  /** column name */
  RerankerScore = 'reranker_score'
}

/** input type for updating data in table "message_sources" */
export interface Message_Sources_Set_Input {
  chunk_id?: InputMaybe<Scalars['uuid']['input']>;
  cosine_similarity?: InputMaybe<Scalars['float8']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  reranker_score?: InputMaybe<Scalars['float8']['input']>;
}

/** order by stddev() on columns of table "message_sources" */
export interface Message_Sources_Stddev_Order_By {
  cosine_similarity?: InputMaybe<Order_By>;
  reranker_score?: InputMaybe<Order_By>;
}

/** order by stddev_pop() on columns of table "message_sources" */
export interface Message_Sources_Stddev_Pop_Order_By {
  cosine_similarity?: InputMaybe<Order_By>;
  reranker_score?: InputMaybe<Order_By>;
}

/** order by stddev_samp() on columns of table "message_sources" */
export interface Message_Sources_Stddev_Samp_Order_By {
  cosine_similarity?: InputMaybe<Order_By>;
  reranker_score?: InputMaybe<Order_By>;
}

/** Streaming cursor of the table "message_sources" */
export interface Message_Sources_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Message_Sources_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Message_Sources_Stream_Cursor_Value_Input {
  chunk_id?: InputMaybe<Scalars['uuid']['input']>;
  cosine_similarity?: InputMaybe<Scalars['float8']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  reranker_score?: InputMaybe<Scalars['float8']['input']>;
}

/** order by sum() on columns of table "message_sources" */
export interface Message_Sources_Sum_Order_By {
  cosine_similarity?: InputMaybe<Order_By>;
  reranker_score?: InputMaybe<Order_By>;
}

/** update columns of table "message_sources" */
export enum Message_Sources_Update_Column {
  /** column name */
  ChunkId = 'chunk_id',
  /** column name */
  CosineSimilarity = 'cosine_similarity',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  RerankerScore = 'reranker_score'
}

export interface Message_Sources_Updates {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Message_Sources_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Message_Sources_Set_Input>;
  /** filter the rows which have to be updated */
  where: Message_Sources_Bool_Exp;
}

/** order by var_pop() on columns of table "message_sources" */
export interface Message_Sources_Var_Pop_Order_By {
  cosine_similarity?: InputMaybe<Order_By>;
  reranker_score?: InputMaybe<Order_By>;
}

/** order by var_samp() on columns of table "message_sources" */
export interface Message_Sources_Var_Samp_Order_By {
  cosine_similarity?: InputMaybe<Order_By>;
  reranker_score?: InputMaybe<Order_By>;
}

/** order by variance() on columns of table "message_sources" */
export interface Message_Sources_Variance_Order_By {
  cosine_similarity?: InputMaybe<Order_By>;
  reranker_score?: InputMaybe<Order_By>;
}

export interface Messages_Aggregate_Bool_Exp {
  bool_and?: InputMaybe<Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Messages_Aggregate_Bool_Exp_Count>;
}

export interface Messages_Aggregate_Bool_Exp_Bool_And {
  arguments: Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
}

export interface Messages_Aggregate_Bool_Exp_Bool_Or {
  arguments: Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
}

export interface Messages_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** order by aggregate values of table "messages" */
export interface Messages_Aggregate_Order_By {
  avg?: InputMaybe<Messages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Messages_Max_Order_By>;
  min?: InputMaybe<Messages_Min_Order_By>;
  stddev?: InputMaybe<Messages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Messages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Messages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Messages_Sum_Order_By>;
  var_pop?: InputMaybe<Messages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Messages_Var_Samp_Order_By>;
  variance?: InputMaybe<Messages_Variance_Order_By>;
}

/** input type for inserting array relation for remote table "messages" */
export interface Messages_Arr_Rel_Insert_Input {
  data: Array<Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Messages_On_Conflict>;
}

/** order by avg() on columns of table "messages" */
export interface Messages_Avg_Order_By {
  position?: InputMaybe<Order_By>;
}

/** Boolean expression to filter rows from the table "messages". All fields are combined with a logical 'AND'. */
export interface Messages_Bool_Exp {
  Attachments?: InputMaybe<Message_Attachments_Bool_Exp>;
  Attachments_aggregate?: InputMaybe<Message_Attachments_Aggregate_Bool_Exp>;
  Chat?: InputMaybe<Chats_Bool_Exp>;
  Sources?: InputMaybe<Message_Sources_Bool_Exp>;
  Sources_aggregate?: InputMaybe<Message_Sources_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<Messages_Bool_Exp>>;
  _not?: InputMaybe<Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Messages_Bool_Exp>>;
  chat_id?: InputMaybe<Uuid_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  full_prompt?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  position?: InputMaybe<Int_Comparison_Exp>;
  reasoning_content?: InputMaybe<String_Comparison_Exp>;
  retrieve_chunks?: InputMaybe<Boolean_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
}

/** unique or primary key constraints on table "messages" */
export enum Messages_Constraint {
  /** unique or primary key constraint on columns "id" */
  MessagesPkey = 'messages_pkey'
}

/** input type for incrementing numeric columns in table "messages" */
export interface Messages_Inc_Input {
  position?: InputMaybe<Scalars['Int']['input']>;
}

/** input type for inserting data into table "messages" */
export interface Messages_Insert_Input {
  Attachments?: InputMaybe<Message_Attachments_Arr_Rel_Insert_Input>;
  Chat?: InputMaybe<Chats_Obj_Rel_Insert_Input>;
  Sources?: InputMaybe<Message_Sources_Arr_Rel_Insert_Input>;
  chat_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  full_prompt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reasoning_content?: InputMaybe<Scalars['String']['input']>;
  retrieve_chunks?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
}

/** order by max() on columns of table "messages" */
export interface Messages_Max_Order_By {
  chat_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  full_prompt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  reasoning_content?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
}

/** order by min() on columns of table "messages" */
export interface Messages_Min_Order_By {
  chat_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  full_prompt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  reasoning_content?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
}

/** input type for inserting object relation for remote table "messages" */
export interface Messages_Obj_Rel_Insert_Input {
  data: Messages_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Messages_On_Conflict>;
}

/** on_conflict condition type for table "messages" */
export interface Messages_On_Conflict {
  constraint: Messages_Constraint;
  update_columns?: Array<Messages_Update_Column>;
  where?: InputMaybe<Messages_Bool_Exp>;
}

/** Ordering options when selecting data from "messages". */
export interface Messages_Order_By {
  Attachments_aggregate?: InputMaybe<Message_Attachments_Aggregate_Order_By>;
  Chat?: InputMaybe<Chats_Order_By>;
  Sources_aggregate?: InputMaybe<Message_Sources_Aggregate_Order_By>;
  chat_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  full_prompt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  reasoning_content?: InputMaybe<Order_By>;
  retrieve_chunks?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
}

/** primary key columns input for table: messages */
export interface Messages_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "messages" */
export enum Messages_Select_Column {
  /** column name */
  ChatId = 'chat_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FullPrompt = 'full_prompt',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  ReasoningContent = 'reasoning_content',
  /** column name */
  RetrieveChunks = 'retrieve_chunks',
  /** column name */
  Role = 'role'
}

/** select "messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "messages" */
export enum Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  RetrieveChunks = 'retrieve_chunks'
}

/** select "messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "messages" */
export enum Messages_Select_Column_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  RetrieveChunks = 'retrieve_chunks'
}

/** input type for updating data in table "messages" */
export interface Messages_Set_Input {
  chat_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  full_prompt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reasoning_content?: InputMaybe<Scalars['String']['input']>;
  retrieve_chunks?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
}

/** order by stddev() on columns of table "messages" */
export interface Messages_Stddev_Order_By {
  position?: InputMaybe<Order_By>;
}

/** order by stddev_pop() on columns of table "messages" */
export interface Messages_Stddev_Pop_Order_By {
  position?: InputMaybe<Order_By>;
}

/** order by stddev_samp() on columns of table "messages" */
export interface Messages_Stddev_Samp_Order_By {
  position?: InputMaybe<Order_By>;
}

/** Streaming cursor of the table "messages" */
export interface Messages_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Messages_Stream_Cursor_Value_Input {
  chat_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  full_prompt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reasoning_content?: InputMaybe<Scalars['String']['input']>;
  retrieve_chunks?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
}

/** order by sum() on columns of table "messages" */
export interface Messages_Sum_Order_By {
  position?: InputMaybe<Order_By>;
}

/** update columns of table "messages" */
export enum Messages_Update_Column {
  /** column name */
  ChatId = 'chat_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FullPrompt = 'full_prompt',
  /** column name */
  Id = 'id',
  /** column name */
  Position = 'position',
  /** column name */
  ReasoningContent = 'reasoning_content',
  /** column name */
  RetrieveChunks = 'retrieve_chunks',
  /** column name */
  Role = 'role'
}

export interface Messages_Updates {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Messages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Messages_Bool_Exp;
}

/** order by var_pop() on columns of table "messages" */
export interface Messages_Var_Pop_Order_By {
  position?: InputMaybe<Order_By>;
}

/** order by var_samp() on columns of table "messages" */
export interface Messages_Var_Samp_Order_By {
  position?: InputMaybe<Order_By>;
}

/** order by variance() on columns of table "messages" */
export interface Messages_Variance_Order_By {
  position?: InputMaybe<Order_By>;
}

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export interface Numeric_Comparison_Exp {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
}

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** append existing jsonb value of filtered columns with new jsonb value */
export interface Organizations_Append_Input {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
}

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export interface Organizations_Bool_Exp {
  EmbeddingModel?: InputMaybe<Ai_Models_Bool_Exp>;
  Favicon?: InputMaybe<Files_Bool_Exp>;
  LargeLanguageModel?: InputMaybe<Ai_Models_Bool_Exp>;
  Logo?: InputMaybe<Files_Bool_Exp>;
  RerankerModel?: InputMaybe<Ai_Models_Bool_Exp>;
  Users?: InputMaybe<Users_Bool_Exp>;
  Users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<Organizations_Bool_Exp>>;
  _not?: InputMaybe<Organizations_Bool_Exp>;
  _or?: InputMaybe<Array<Organizations_Bool_Exp>>;
  add_document_name_to_chunks?: InputMaybe<Boolean_Comparison_Exp>;
  app_name?: InputMaybe<String_Comparison_Exp>;
  base_model_system_prompt?: InputMaybe<String_Comparison_Exp>;
  base_model_temperature?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  embedding_model_id?: InputMaybe<Uuid_Comparison_Exp>;
  favicon_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  llm_id?: InputMaybe<Uuid_Comparison_Exp>;
  logo_file_id?: InputMaybe<Uuid_Comparison_Exp>;
  max_chunks_llm?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  reranker_model_id?: InputMaybe<Uuid_Comparison_Exp>;
  select_chunks_min_reranker?: InputMaybe<Numeric_Comparison_Exp>;
  select_chunks_min_similarity?: InputMaybe<Numeric_Comparison_Exp>;
  select_chunks_reranker_margin?: InputMaybe<Numeric_Comparison_Exp>;
  select_chunks_similarity_margin?: InputMaybe<Numeric_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  title_generation_system_prompt?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_id?: InputMaybe<Uuid_Comparison_Exp>;
}

/** unique or primary key constraints on table "organizations" */
export enum Organizations_Constraint {
  /** unique or primary key constraint on columns "favicon_file_id" */
  OrganizationsFaviconFileIdKey = 'organizations_favicon_file_id_key',
  /** unique or primary key constraint on columns "logo_file_id" */
  OrganizationsLogoFileIdKey = 'organizations_logo_file_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationsPkey = 'organizations_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export interface Organizations_Delete_At_Path_Input {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export interface Organizations_Delete_Elem_Input {
  settings?: InputMaybe<Scalars['Int']['input']>;
}

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export interface Organizations_Delete_Key_Input {
  settings?: InputMaybe<Scalars['String']['input']>;
}

/** input type for incrementing numeric columns in table "organizations" */
export interface Organizations_Inc_Input {
  base_model_temperature?: InputMaybe<Scalars['numeric']['input']>;
  max_chunks_llm?: InputMaybe<Scalars['Int']['input']>;
  select_chunks_min_reranker?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_min_similarity?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_reranker_margin?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_similarity_margin?: InputMaybe<Scalars['numeric']['input']>;
}

/** input type for inserting data into table "organizations" */
export interface Organizations_Insert_Input {
  EmbeddingModel?: InputMaybe<Ai_Models_Obj_Rel_Insert_Input>;
  Favicon?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  LargeLanguageModel?: InputMaybe<Ai_Models_Obj_Rel_Insert_Input>;
  Logo?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  RerankerModel?: InputMaybe<Ai_Models_Obj_Rel_Insert_Input>;
  Users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  add_document_name_to_chunks?: InputMaybe<Scalars['Boolean']['input']>;
  app_name?: InputMaybe<Scalars['String']['input']>;
  base_model_system_prompt?: InputMaybe<Scalars['String']['input']>;
  base_model_temperature?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  embedding_model_id?: InputMaybe<Scalars['uuid']['input']>;
  favicon_file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  llm_id?: InputMaybe<Scalars['uuid']['input']>;
  logo_file_id?: InputMaybe<Scalars['uuid']['input']>;
  max_chunks_llm?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reranker_model_id?: InputMaybe<Scalars['uuid']['input']>;
  select_chunks_min_reranker?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_min_similarity?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_reranker_margin?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_similarity_margin?: InputMaybe<Scalars['numeric']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  title_generation_system_prompt?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** input type for inserting object relation for remote table "organizations" */
export interface Organizations_Obj_Rel_Insert_Input {
  data: Organizations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
}

/** on_conflict condition type for table "organizations" */
export interface Organizations_On_Conflict {
  constraint: Organizations_Constraint;
  update_columns?: Array<Organizations_Update_Column>;
  where?: InputMaybe<Organizations_Bool_Exp>;
}

/** Ordering options when selecting data from "organizations". */
export interface Organizations_Order_By {
  EmbeddingModel?: InputMaybe<Ai_Models_Order_By>;
  Favicon?: InputMaybe<Files_Order_By>;
  LargeLanguageModel?: InputMaybe<Ai_Models_Order_By>;
  Logo?: InputMaybe<Files_Order_By>;
  RerankerModel?: InputMaybe<Ai_Models_Order_By>;
  Users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  add_document_name_to_chunks?: InputMaybe<Order_By>;
  app_name?: InputMaybe<Order_By>;
  base_model_system_prompt?: InputMaybe<Order_By>;
  base_model_temperature?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_id?: InputMaybe<Order_By>;
  embedding_model_id?: InputMaybe<Order_By>;
  favicon_file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  llm_id?: InputMaybe<Order_By>;
  logo_file_id?: InputMaybe<Order_By>;
  max_chunks_llm?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reranker_model_id?: InputMaybe<Order_By>;
  select_chunks_min_reranker?: InputMaybe<Order_By>;
  select_chunks_min_similarity?: InputMaybe<Order_By>;
  select_chunks_reranker_margin?: InputMaybe<Order_By>;
  select_chunks_similarity_margin?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  title_generation_system_prompt?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_id?: InputMaybe<Order_By>;
}

/** primary key columns input for table: organizations */
export interface Organizations_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** prepend existing jsonb value of filtered columns with new jsonb value */
export interface Organizations_Prepend_Input {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
}

/** select columns of table "organizations" */
export enum Organizations_Select_Column {
  /** column name */
  AddDocumentNameToChunks = 'add_document_name_to_chunks',
  /** column name */
  AppName = 'app_name',
  /** column name */
  BaseModelSystemPrompt = 'base_model_system_prompt',
  /** column name */
  BaseModelTemperature = 'base_model_temperature',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  EmbeddingModelId = 'embedding_model_id',
  /** column name */
  FaviconFileId = 'favicon_file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  LlmId = 'llm_id',
  /** column name */
  LogoFileId = 'logo_file_id',
  /** column name */
  MaxChunksLlm = 'max_chunks_llm',
  /** column name */
  Name = 'name',
  /** column name */
  RerankerModelId = 'reranker_model_id',
  /** column name */
  SelectChunksMinReranker = 'select_chunks_min_reranker',
  /** column name */
  SelectChunksMinSimilarity = 'select_chunks_min_similarity',
  /** column name */
  SelectChunksRerankerMargin = 'select_chunks_reranker_margin',
  /** column name */
  SelectChunksSimilarityMargin = 'select_chunks_similarity_margin',
  /** column name */
  Settings = 'settings',
  /** column name */
  TitleGenerationSystemPrompt = 'title_generation_system_prompt',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** input type for updating data in table "organizations" */
export interface Organizations_Set_Input {
  add_document_name_to_chunks?: InputMaybe<Scalars['Boolean']['input']>;
  app_name?: InputMaybe<Scalars['String']['input']>;
  base_model_system_prompt?: InputMaybe<Scalars['String']['input']>;
  base_model_temperature?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  embedding_model_id?: InputMaybe<Scalars['uuid']['input']>;
  favicon_file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  llm_id?: InputMaybe<Scalars['uuid']['input']>;
  logo_file_id?: InputMaybe<Scalars['uuid']['input']>;
  max_chunks_llm?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reranker_model_id?: InputMaybe<Scalars['uuid']['input']>;
  select_chunks_min_reranker?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_min_similarity?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_reranker_margin?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_similarity_margin?: InputMaybe<Scalars['numeric']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  title_generation_system_prompt?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** Streaming cursor of the table "organizations" */
export interface Organizations_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Organizations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Organizations_Stream_Cursor_Value_Input {
  add_document_name_to_chunks?: InputMaybe<Scalars['Boolean']['input']>;
  app_name?: InputMaybe<Scalars['String']['input']>;
  base_model_system_prompt?: InputMaybe<Scalars['String']['input']>;
  base_model_temperature?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_id?: InputMaybe<Scalars['uuid']['input']>;
  embedding_model_id?: InputMaybe<Scalars['uuid']['input']>;
  favicon_file_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  llm_id?: InputMaybe<Scalars['uuid']['input']>;
  logo_file_id?: InputMaybe<Scalars['uuid']['input']>;
  max_chunks_llm?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reranker_model_id?: InputMaybe<Scalars['uuid']['input']>;
  select_chunks_min_reranker?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_min_similarity?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_reranker_margin?: InputMaybe<Scalars['numeric']['input']>;
  select_chunks_similarity_margin?: InputMaybe<Scalars['numeric']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  title_generation_system_prompt?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_id?: InputMaybe<Scalars['uuid']['input']>;
}

/** update columns of table "organizations" */
export enum Organizations_Update_Column {
  /** column name */
  AddDocumentNameToChunks = 'add_document_name_to_chunks',
  /** column name */
  AppName = 'app_name',
  /** column name */
  BaseModelSystemPrompt = 'base_model_system_prompt',
  /** column name */
  BaseModelTemperature = 'base_model_temperature',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedById = 'deleted_by_id',
  /** column name */
  EmbeddingModelId = 'embedding_model_id',
  /** column name */
  FaviconFileId = 'favicon_file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  LlmId = 'llm_id',
  /** column name */
  LogoFileId = 'logo_file_id',
  /** column name */
  MaxChunksLlm = 'max_chunks_llm',
  /** column name */
  Name = 'name',
  /** column name */
  RerankerModelId = 'reranker_model_id',
  /** column name */
  SelectChunksMinReranker = 'select_chunks_min_reranker',
  /** column name */
  SelectChunksMinSimilarity = 'select_chunks_min_similarity',
  /** column name */
  SelectChunksRerankerMargin = 'select_chunks_reranker_margin',
  /** column name */
  SelectChunksSimilarityMargin = 'select_chunks_similarity_margin',
  /** column name */
  Settings = 'settings',
  /** column name */
  TitleGenerationSystemPrompt = 'title_generation_system_prompt',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

export interface Organizations_Updates {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organizations_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organizations_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organizations_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organizations_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organizations_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organizations_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organizations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organizations_Bool_Exp;
}

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export interface Timestamp_Comparison_Exp {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
}

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export interface Timestamptz_Comparison_Exp {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
}

export interface Users_Aggregate_Bool_Exp {
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
}

export interface Users_Aggregate_Bool_Exp_Count {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
}

/** order by aggregate values of table "users" */
export interface Users_Aggregate_Order_By {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
}

/** input type for inserting array relation for remote table "users" */
export interface Users_Arr_Rel_Insert_Input {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
}

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export interface Users_Bool_Exp {
  Organization?: InputMaybe<Organizations_Bool_Exp>;
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
}

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for inserting data into table "users" */
export interface Users_Insert_Input {
  Organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** order by max() on columns of table "users" */
export interface Users_Max_Order_By {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** order by min() on columns of table "users" */
export interface Users_Min_Order_By {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** input type for inserting object relation for remote table "users" */
export interface Users_Obj_Rel_Insert_Input {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
}

/** on_conflict condition type for table "users" */
export interface Users_On_Conflict {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
}

/** Ordering options when selecting data from "users". */
export interface Users_Order_By {
  Organization?: InputMaybe<Organizations_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
}

/** primary key columns input for table: users */
export interface Users_Pk_Columns_Input {
  id: Scalars['uuid']['input'];
}

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "users" */
export interface Users_Set_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** Streaming cursor of the table "users" */
export interface Users_Stream_Cursor_Input {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
}

/** Initial value of the column from where the streaming should start */
export interface Users_Stream_Cursor_Value_Input {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
}

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Role = 'role',
  /** column name */
  UpdatedAt = 'updated_at'
}

export interface Users_Updates {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export interface Uuid_Comparison_Exp {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
}

/** Boolean expression to compare columns of type "vector". All fields are combined with logical 'AND'. */
export interface Vector_Comparison_Exp {
  _eq?: InputMaybe<Scalars['vector']['input']>;
  _gt?: InputMaybe<Scalars['vector']['input']>;
  _gte?: InputMaybe<Scalars['vector']['input']>;
  _in?: InputMaybe<Array<Scalars['vector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['vector']['input']>;
  _lte?: InputMaybe<Scalars['vector']['input']>;
  _neq?: InputMaybe<Scalars['vector']['input']>;
  _nin?: InputMaybe<Array<Scalars['vector']['input']>>;
}

export type GetAiModelsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Ai_Models_Bool_Exp>;
  order_by?: InputMaybe<Array<Ai_Models_Order_By>>;
}>;


export type GetAiModelsQuery = { ai_models: Array<{ __typename: 'ai_models', id: string, model: string, type: string, provider: string, type_label?: string | null | undefined, created_at: string, model_usage_count?: number | null | undefined }>, ai_models_aggregate: { __typename: 'ai_models_aggregate', aggregate?: { __typename: 'ai_models_aggregate_fields', count: number } | null | undefined } };

export type GetAiModelQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAiModelQuery = { ai_models_by_pk?: { __typename: 'ai_models', id: string, model: string, type: string, type_label?: string | null | undefined, provider: string, url: string, huggingface_id: string, context_length: number, api_key: string, additional_config: any, model_usage_count?: number | null | undefined } | null | undefined };

export type InsertAiModelMutationVariables = Exact<{
  ai_model: Ai_Models_Insert_Input;
}>;


export type InsertAiModelMutation = { insert_ai_models_one?: { __typename: 'ai_models', id: string } | null | undefined };

export type UpdateAiModelMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  aiModelUpdate?: InputMaybe<Ai_Models_Set_Input>;
}>;


export type UpdateAiModelMutation = { update_ai_models_by_pk?: { __typename: 'ai_models', id: string } | null | undefined };

export type GetChatQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetChatQuery = { chats_by_pk?: { __typename: 'chats', id: string, title: string, Messages: Array<{ __typename: 'messages', role: string, content: string, reasoning_content?: string | null | undefined, position: number, Sources: Array<{ __typename: 'message_sources', cosine_similarity: any, reranker_score?: any | null | undefined, Chunk: { __typename: 'chunks', id: string, text: string, pages?: Array<number> | null | undefined, Document?: { __typename: 'documents', id: string, deleted_at?: string | null | undefined, File: { __typename: 'files', id: string, name: string } } | null | undefined } }>, Attachments: Array<{ __typename: 'message_attachments', id: string, File: { __typename: 'files', id: string, name: string } }> }>, Collection?: { __typename: 'collections', id: string, name: string, description: string, created_at: string, status?: string | null | undefined, deleted_at?: string | null | undefined, updated_at?: string | null | undefined, user_prompt_template: string, private: boolean, Documents: Array<{ __typename: 'documents', id: string, status: string, created_at: string, deleted_at?: string | null | undefined, File: { __typename: 'files', id: string, name: string } }> } | null | undefined } | null | undefined };

export type GetChatsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Chats_Bool_Exp>;
  order_by?: InputMaybe<Array<Chats_Order_By>>;
}>;


export type GetChatsQuery = { chats: Array<{ __typename: 'chats', id: string, title: string }>, chats_aggregate: { __typename: 'chats_aggregate', aggregate?: { __typename: 'chats_aggregate_fields', count: number } | null | undefined } };

export type UpdateChatMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  chatUpdates?: InputMaybe<Chats_Set_Input>;
}>;


export type UpdateChatMutation = { update_chats_by_pk?: { __typename: 'chats', id: string } | null | undefined };

export type GetChunkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetChunkQuery = { chunks_by_pk?: { __typename: 'chunks', id: string, pages?: Array<number> | null | undefined, Document?: { __typename: 'documents', File: { __typename: 'files', id: string, name: string } } | null | undefined } | null | undefined };

export type GetCollectionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Collections_Bool_Exp>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
}>;


export type GetCollectionsQuery = { collections: Array<{ __typename: 'collections', id: string, name: string, description: string, created_at: string, status?: string | null | undefined, deleted_at?: string | null | undefined, updated_at?: string | null | undefined, private: boolean, Documents: Array<{ __typename: 'documents', id: string, status: string, created_at: string, File: { __typename: 'files', id: string, name: string } }> }>, collections_aggregate: { __typename: 'collections_aggregate', aggregate?: { __typename: 'collections_aggregate_fields', count: number } | null | undefined } };

export type GetCollectionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  documents_order_by?: InputMaybe<Array<Documents_Order_By>>;
}>;


export type GetCollectionQuery = { collections_by_pk?: { __typename: 'collections', id: string, name: string, description: string, created_at: string, updated_at?: string | null | undefined, status?: string | null | undefined, deleted_at?: string | null | undefined, system_prompt: string, llm_temperature: any, private: boolean, Documents: Array<{ __typename: 'documents', id: string, status: string, created_at: string, File: { __typename: 'files', id: string, name: string } }> } | null | undefined };

export type UpdateCollectionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  collectionUpdates?: InputMaybe<Collections_Set_Input>;
  deletedFileIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  updatedById: Scalars['uuid']['input'];
  newDocuments?: InputMaybe<Array<Documents_Insert_Input>>;
}>;


export type UpdateCollectionMutation = { update_collections_by_pk?: { __typename: 'collections', id: string } | null | undefined, delete_documents?: { __typename: 'documents_mutation_response', affected_rows: number } | null | undefined, insert_documents?: { __typename: 'documents_mutation_response', affected_rows: number } | null | undefined };

export type InsertCollectionMutationVariables = Exact<{
  collection: Collections_Insert_Input;
}>;


export type InsertCollectionMutation = { insert_collections_one?: { __typename: 'collections', id: string } | null | undefined };

export type GetDefaultSystemPromptQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultSystemPromptQuery = { get_default_system_prompt: Array<{ __typename: 'get_default_system_prompt_result_format', system_prompt?: string | null | undefined }> };

export type GetDocumentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Documents_Bool_Exp>;
}>;


export type GetDocumentsQuery = { documents: Array<{ __typename: 'documents', id: string, status: string, created_at: string }>, documents_aggregate: { __typename: 'documents_aggregate', aggregate?: { __typename: 'documents_aggregate_fields', count: number } | null | undefined } };

export type GetDocumentFileIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDocumentFileIdQuery = { documents_by_pk?: { __typename: 'documents', id: string, file_id: string } | null | undefined };

export type UpdateFilesMutationVariables = Exact<{
  fileUpdates?: InputMaybe<Files_Set_Input>;
  fileIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
}>;


export type UpdateFilesMutation = { update_files?: { __typename: 'files_mutation_response', affected_rows: number } | null | undefined };

export type GetMessageAttachmentsByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetMessageAttachmentsByPkQuery = { message_attachments_by_pk?: { __typename: 'message_attachments', id: string, message_id?: string | null | undefined, full_text: string, File: { __typename: 'files', id: string, name: string } } | null | undefined };

export type DeleteMessageAttachmentByPkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteMessageAttachmentByPkMutation = { delete_message_attachments_by_pk?: { __typename: 'message_attachments', id: string, message_id?: string | null | undefined, file_id: string } | null | undefined };

export type GetOrganizationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Organizations_Bool_Exp>;
}>;


export type GetOrganizationsQuery = { organizations: Array<{ __typename: 'organizations', id: string, name: string, app_name?: string | null | undefined, language: string, settings: any, Logo: { __typename: 'files', id: string }, Favicon?: { __typename: 'files', id: string } | null | undefined, Users_aggregate: { __typename: 'users_aggregate', aggregate?: { __typename: 'users_aggregate_fields', count: number } | null | undefined } }>, organizations_aggregate: { __typename: 'organizations_aggregate', aggregate?: { __typename: 'organizations_aggregate_fields', count: number } | null | undefined } };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganizationQuery = { organizations_by_pk?: { __typename: 'organizations', id: string, name: string, app_name?: string | null | undefined, settings: any, language: string, base_model_system_prompt: string, base_model_temperature: any, title_generation_system_prompt: string, max_chunks_llm: number, add_document_name_to_chunks: boolean, select_chunks_min_similarity: any, select_chunks_min_reranker: any, select_chunks_similarity_margin: any, select_chunks_reranker_margin: any, Logo: { __typename: 'files', id: string, name: string }, Favicon?: { __typename: 'files', id: string, name: string } | null | undefined, LargeLanguageModel: { __typename: 'ai_models', id: string, model: string, type: string, provider: string, created_at: string, type_label?: string | null | undefined, model_usage_count?: number | null | undefined }, EmbeddingModel: { __typename: 'ai_models', id: string, model: string, type: string, provider: string, created_at: string, type_label?: string | null | undefined, model_usage_count?: number | null | undefined }, RerankerModel?: { __typename: 'ai_models', id: string, model: string, type: string, provider: string, created_at: string, type_label?: string | null | undefined, model_usage_count?: number | null | undefined } | null | undefined } | null | undefined };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  organizationUpdate?: InputMaybe<Organizations_Set_Input>;
  deletedFileIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  updatedById: Scalars['uuid']['input'];
}>;


export type UpdateOrganizationMutation = { update_organizations_by_pk?: { __typename: 'organizations', id: string } | null | undefined, delete_files?: { __typename: 'files_mutation_response', affected_rows: number } | null | undefined };

export type InsertOrganizationMutationVariables = Exact<{
  organization: Organizations_Insert_Input;
}>;


export type InsertOrganizationMutation = { insert_organizations_one?: { __typename: 'organizations', id: string } | null | undefined };

export type GetUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserQuery = { users_by_pk?: { __typename: 'users', email: string, id: string, name?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, role: string, Organization?: { __typename: 'organizations', name: string, app_name?: string | null | undefined, id: string, language: string, settings: any, Logo: { __typename: 'files', id: string }, Favicon?: { __typename: 'files', id: string } | null | undefined } | null | undefined } | null | undefined };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set?: InputMaybe<Users_Set_Input>;
}>;


export type UpdateUserMutation = { update_users_by_pk?: { __typename: 'users', id: string } | null | undefined };

export type GetUsersQueryVariables = Exact<{
  where?: InputMaybe<Users_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUsersQuery = { users: Array<{ __typename: 'users', id: string, name?: string | null | undefined, email: string, created_at: string, role: string, first_name?: string | null | undefined, last_name?: string | null | undefined }>, users_aggregate: { __typename: 'users_aggregate', aggregate?: { __typename: 'users_aggregate_fields', count: number } | null | undefined } };

export type InsertUserMutationVariables = Exact<{
  user: Users_Insert_Input;
}>;


export type InsertUserMutation = { insert_users_one?: { __typename: 'users', id: string } | null | undefined };

export type UpdateUsersMutationVariables = Exact<{
  updates: Users_Set_Input;
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type UpdateUsersMutation = { update_users?: { __typename: 'users_mutation_response', returning: Array<{ __typename: 'users', id: string }> } | null | undefined };

export const GetAiModelsDocument = gql`
    query getAiModels($limit: Int = 10, $offset: Int = 0, $where: ai_models_bool_exp = {}, $order_by: [ai_models_order_by!] = {model: asc}) {
  ai_models(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    id
    model
    type
    provider
    type_label
    created_at
    model_usage_count
  }
  ai_models_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAiModelsGQL extends Apollo.Query<GetAiModelsQuery, GetAiModelsQueryVariables> {
    override document = GetAiModelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAiModelDocument = gql`
    query getAiModel($id: uuid!) {
  ai_models_by_pk(id: $id) {
    id
    model
    type
    type_label
    provider
    url
    huggingface_id
    context_length
    api_key
    additional_config
    model_usage_count
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAiModelGQL extends Apollo.Query<GetAiModelQuery, GetAiModelQueryVariables> {
    override document = GetAiModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertAiModelDocument = gql`
    mutation insertAiModel($ai_model: ai_models_insert_input!) {
  insert_ai_models_one(object: $ai_model) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertAiModelGQL extends Apollo.Mutation<InsertAiModelMutation, InsertAiModelMutationVariables> {
    override document = InsertAiModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAiModelDocument = gql`
    mutation updateAiModel($id: uuid!, $aiModelUpdate: ai_models_set_input = {}) {
  update_ai_models_by_pk(pk_columns: {id: $id}, _set: $aiModelUpdate) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAiModelGQL extends Apollo.Mutation<UpdateAiModelMutation, UpdateAiModelMutationVariables> {
    override document = UpdateAiModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChatDocument = gql`
    query getChat($id: uuid!) {
  chats_by_pk(id: $id) {
    id
    Messages(order_by: {position: desc}) {
      role
      content
      reasoning_content
      position
      Sources {
        cosine_similarity
        reranker_score
        Chunk {
          id
          text
          pages
          Document {
            id
            deleted_at
            File {
              id
              name
            }
          }
        }
      }
      Attachments {
        id
        File {
          id
          name
        }
      }
    }
    title
    Collection {
      id
      name
      description
      created_at
      status
      deleted_at
      updated_at
      user_prompt_template
      private
      Documents(where: {deleted_at: {_is_null: true}}, order_by: {created_at: desc}) {
        id
        status
        created_at
        deleted_at
        File {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChatGQL extends Apollo.Query<GetChatQuery, GetChatQueryVariables> {
    override document = GetChatDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChatsDocument = gql`
    query getChats($limit: Int = 10, $offset: Int = 0, $where: chats_bool_exp = {}, $order_by: [chats_order_by!] = {last_modified_at: desc}) {
  chats(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    id
    title
  }
  chats_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChatsGQL extends Apollo.Query<GetChatsQuery, GetChatsQueryVariables> {
    override document = GetChatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateChatDocument = gql`
    mutation updateChat($id: uuid!, $chatUpdates: chats_set_input = {}) {
  update_chats_by_pk(pk_columns: {id: $id}, _set: $chatUpdates) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateChatGQL extends Apollo.Mutation<UpdateChatMutation, UpdateChatMutationVariables> {
    override document = UpdateChatDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChunkDocument = gql`
    query getChunk($id: uuid!) {
  chunks_by_pk(id: $id) {
    id
    pages
    Document {
      File {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChunkGQL extends Apollo.Query<GetChunkQuery, GetChunkQueryVariables> {
    override document = GetChunkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCollectionsDocument = gql`
    query getCollections($limit: Int = 10, $offset: Int = 0, $where: collections_bool_exp = {}, $order_by: [collections_order_by!] = {name: asc}) {
  collections(limit: $limit, offset: $offset, where: $where, order_by: $order_by) {
    id
    name
    description
    created_at
    status
    deleted_at
    updated_at
    private
    Documents(where: {deleted_at: {_is_null: true}}, order_by: {created_at: desc}) {
      id
      status
      created_at
      File {
        id
        name
      }
    }
  }
  collections_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCollectionsGQL extends Apollo.Query<GetCollectionsQuery, GetCollectionsQueryVariables> {
    override document = GetCollectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCollectionDocument = gql`
    query getCollection($id: uuid!, $documents_order_by: [documents_order_by!] = []) {
  collections_by_pk(id: $id) {
    id
    name
    description
    created_at
    updated_at
    status
    deleted_at
    system_prompt
    llm_temperature
    private
    Documents(where: {deleted_at: {_is_null: true}}, order_by: $documents_order_by) {
      id
      status
      created_at
      File {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCollectionGQL extends Apollo.Query<GetCollectionQuery, GetCollectionQueryVariables> {
    override document = GetCollectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCollectionDocument = gql`
    mutation updateCollection($id: uuid!, $collectionUpdates: collections_set_input = {}, $deletedFileIds: [uuid!] = [], $updatedById: uuid!, $newDocuments: [documents_insert_input!] = []) {
  update_collections_by_pk(pk_columns: {id: $id}, _set: $collectionUpdates) {
    id
  }
  delete_documents: update_documents(
    where: {file_id: {_in: $deletedFileIds}}
    _set: {deleted_at: "now()", deleted_by_id: $updatedById}
  ) {
    affected_rows
  }
  insert_documents(objects: $newDocuments) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCollectionGQL extends Apollo.Mutation<UpdateCollectionMutation, UpdateCollectionMutationVariables> {
    override document = UpdateCollectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertCollectionDocument = gql`
    mutation insertCollection($collection: collections_insert_input!) {
  insert_collections_one(object: $collection) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertCollectionGQL extends Apollo.Mutation<InsertCollectionMutation, InsertCollectionMutationVariables> {
    override document = InsertCollectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDefaultSystemPromptDocument = gql`
    query getDefaultSystemPrompt {
  get_default_system_prompt {
    system_prompt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDefaultSystemPromptGQL extends Apollo.Query<GetDefaultSystemPromptQuery, GetDefaultSystemPromptQueryVariables> {
    override document = GetDefaultSystemPromptDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentsDocument = gql`
    query getDocuments($limit: Int = 10, $offset: Int = 0, $where: documents_bool_exp = {}) {
  documents(limit: $limit, offset: $offset, where: $where) {
    id
    status
    created_at
  }
  documents_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentsGQL extends Apollo.Query<GetDocumentsQuery, GetDocumentsQueryVariables> {
    override document = GetDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDocumentFileIdDocument = gql`
    query GetDocumentFileId($id: uuid!) {
  documents_by_pk(id: $id) {
    id
    file_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDocumentFileIdGQL extends Apollo.Query<GetDocumentFileIdQuery, GetDocumentFileIdQueryVariables> {
    override document = GetDocumentFileIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFilesDocument = gql`
    mutation updateFiles($fileUpdates: files_set_input = {}, $fileIds: [uuid!] = []) {
  update_files(where: {id: {_in: $fileIds}}, _set: $fileUpdates) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFilesGQL extends Apollo.Mutation<UpdateFilesMutation, UpdateFilesMutationVariables> {
    override document = UpdateFilesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMessageAttachmentsByPkDocument = gql`
    query getMessageAttachmentsByPk($id: uuid!) {
  message_attachments_by_pk(id: $id) {
    id
    message_id
    full_text
    File {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMessageAttachmentsByPkGQL extends Apollo.Query<GetMessageAttachmentsByPkQuery, GetMessageAttachmentsByPkQueryVariables> {
    override document = GetMessageAttachmentsByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMessageAttachmentByPkDocument = gql`
    mutation deleteMessageAttachmentByPk($id: uuid!) {
  delete_message_attachments_by_pk(id: $id) {
    id
    message_id
    file_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMessageAttachmentByPkGQL extends Apollo.Mutation<DeleteMessageAttachmentByPkMutation, DeleteMessageAttachmentByPkMutationVariables> {
    override document = DeleteMessageAttachmentByPkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrganizationsDocument = gql`
    query getOrganizations($limit: Int = 10, $offset: Int = 0, $where: organizations_bool_exp = {}) {
  organizations(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {name: asc}
  ) {
    id
    name
    app_name
    language
    Logo {
      id
    }
    Favicon {
      id
    }
    settings
    Users_aggregate(where: {deleted_at: {_is_null: true}}) {
      aggregate {
        count
      }
    }
  }
  organizations_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrganizationsGQL extends Apollo.Query<GetOrganizationsQuery, GetOrganizationsQueryVariables> {
    override document = GetOrganizationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrganizationDocument = gql`
    query getOrganization($id: uuid!) {
  organizations_by_pk(id: $id) {
    id
    name
    app_name
    settings
    language
    base_model_system_prompt
    base_model_temperature
    title_generation_system_prompt
    max_chunks_llm
    add_document_name_to_chunks
    select_chunks_min_similarity
    select_chunks_min_reranker
    select_chunks_similarity_margin
    select_chunks_reranker_margin
    Logo {
      id
      name
    }
    Favicon {
      id
      name
    }
    settings
    LargeLanguageModel {
      id
      model
      type
      provider
      created_at
      type_label
      model_usage_count
    }
    EmbeddingModel {
      id
      model
      type
      provider
      created_at
      type_label
      model_usage_count
    }
    RerankerModel {
      id
      model
      type
      provider
      created_at
      type_label
      model_usage_count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrganizationGQL extends Apollo.Query<GetOrganizationQuery, GetOrganizationQueryVariables> {
    override document = GetOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($id: uuid!, $organizationUpdate: organizations_set_input = {}, $deletedFileIds: [uuid!] = [], $updatedById: uuid!) {
  update_organizations_by_pk(pk_columns: {id: $id}, _set: $organizationUpdate) {
    id
  }
  delete_files: update_files(
    where: {id: {_in: $deletedFileIds}}
    _set: {deleted_at: "now()", deleted_by_id: $updatedById}
  ) {
    affected_rows
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrganizationGQL extends Apollo.Mutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables> {
    override document = UpdateOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertOrganizationDocument = gql`
    mutation insertOrganization($organization: organizations_insert_input!) {
  insert_organizations_one(object: $organization) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertOrganizationGQL extends Apollo.Mutation<InsertOrganizationMutation, InsertOrganizationMutationVariables> {
    override document = InsertOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserDocument = gql`
    query getUser($id: uuid!) {
  users_by_pk(id: $id) {
    email
    id
    name
    first_name
    last_name
    role
    Organization {
      name
      app_name
      id
      language
      Logo {
        id
      }
      Favicon {
        id
      }
      settings
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserGQL extends Apollo.Query<GetUserQuery, GetUserQueryVariables> {
    override document = GetUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation updateUser($id: uuid!, $_set: users_set_input = {}) {
  update_users_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    override document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersDocument = gql`
    query getUsers($where: users_bool_exp = {}, $limit: Int = 10, $offset: Int = 0) {
  users(where: $where, limit: $limit, offset: $offset) {
    id
    name
    email
    created_at
    role
    first_name
    last_name
  }
  users_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersGQL extends Apollo.Query<GetUsersQuery, GetUsersQueryVariables> {
    override document = GetUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InsertUserDocument = gql`
    mutation insertUser($user: users_insert_input!) {
  insert_users_one(object: $user) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InsertUserGQL extends Apollo.Mutation<InsertUserMutation, InsertUserMutationVariables> {
    override document = InsertUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUsersDocument = gql`
    mutation updateUsers($updates: users_set_input!, $where: users_bool_exp = {}) {
  update_users(where: $where, _set: $updates) {
    returning {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUsersGQL extends Apollo.Mutation<UpdateUsersMutation, UpdateUsersMutationVariables> {
    override document = UpdateUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

  type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

  interface WatchQueryOptionsAlone<V extends ApolloCore.OperationVariables> extends Omit<ApolloCore.ApolloClient.WatchQueryOptions<V>, 'query' | 'variables'> {}

  interface QueryOptionsAlone<V> extends Omit<ApolloCore.ApolloClient.QueryOptions<V>, 'query' | 'variables'> {}

  interface MutationOptionsAlone<T, V> extends Omit<ApolloCore.ApolloClient.MutateOptions<V>, 'mutation' | 'variables'> {}

  @Injectable({ providedIn: 'root' })
  export class ApolloService {
    constructor(
      private getAiModelsGql: GetAiModelsGQL,
      private getAiModelGql: GetAiModelGQL,
      private insertAiModelGql: InsertAiModelGQL,
      private updateAiModelGql: UpdateAiModelGQL,
      private getChatGql: GetChatGQL,
      private getChatsGql: GetChatsGQL,
      private updateChatGql: UpdateChatGQL,
      private getChunkGql: GetChunkGQL,
      private getCollectionsGql: GetCollectionsGQL,
      private getCollectionGql: GetCollectionGQL,
      private updateCollectionGql: UpdateCollectionGQL,
      private insertCollectionGql: InsertCollectionGQL,
      private getDefaultSystemPromptGql: GetDefaultSystemPromptGQL,
      private getDocumentsGql: GetDocumentsGQL,
      private getDocumentFileIdGql: GetDocumentFileIdGQL,
      private updateFilesGql: UpdateFilesGQL,
      private getMessageAttachmentsByPkGql: GetMessageAttachmentsByPkGQL,
      private deleteMessageAttachmentByPkGql: DeleteMessageAttachmentByPkGQL,
      private getOrganizationsGql: GetOrganizationsGQL,
      private getOrganizationGql: GetOrganizationGQL,
      private updateOrganizationGql: UpdateOrganizationGQL,
      private insertOrganizationGql: InsertOrganizationGQL,
      private getUserGql: GetUserGQL,
      private updateUserGql: UpdateUserGQL,
      private getUsersGql: GetUsersGQL,
      private insertUserGql: InsertUserGQL,
      private updateUsersGql: UpdateUsersGQL
    ) {}
      
    getAiModels(variables?: GetAiModelsQueryVariables, options?: QueryOptionsAlone<GetAiModelsQueryVariables>) {
      return this.getAiModelsGql.fetch({variables})
    }
    
    getAiModelsWatch(variables?: GetAiModelsQueryVariables, options?: WatchQueryOptionsAlone<GetAiModelsQueryVariables>) {
      return this.getAiModelsGql.watch({variables})
    }
    
    getAiModel(variables: GetAiModelQueryVariables, options?: QueryOptionsAlone<GetAiModelQueryVariables>) {
      return this.getAiModelGql.fetch({variables})
    }
    
    getAiModelWatch(variables: GetAiModelQueryVariables, options?: WatchQueryOptionsAlone<GetAiModelQueryVariables>) {
      return this.getAiModelGql.watch({variables})
    }
    
    insertAiModel(variables: InsertAiModelMutationVariables, options?: MutationOptionsAlone<InsertAiModelMutation, InsertAiModelMutationVariables>) {
      return this.insertAiModelGql.mutate({variables})
    }
    
    updateAiModel(variables: UpdateAiModelMutationVariables, options?: MutationOptionsAlone<UpdateAiModelMutation, UpdateAiModelMutationVariables>) {
      return this.updateAiModelGql.mutate({variables})
    }
    
    getChat(variables: GetChatQueryVariables, options?: QueryOptionsAlone<GetChatQueryVariables>) {
      return this.getChatGql.fetch({variables})
    }
    
    getChatWatch(variables: GetChatQueryVariables, options?: WatchQueryOptionsAlone<GetChatQueryVariables>) {
      return this.getChatGql.watch({variables})
    }
    
    getChats(variables?: GetChatsQueryVariables, options?: QueryOptionsAlone<GetChatsQueryVariables>) {
      return this.getChatsGql.fetch({variables})
    }
    
    getChatsWatch(variables?: GetChatsQueryVariables, options?: WatchQueryOptionsAlone<GetChatsQueryVariables>) {
      return this.getChatsGql.watch({variables})
    }
    
    updateChat(variables: UpdateChatMutationVariables, options?: MutationOptionsAlone<UpdateChatMutation, UpdateChatMutationVariables>) {
      return this.updateChatGql.mutate({variables})
    }
    
    getChunk(variables: GetChunkQueryVariables, options?: QueryOptionsAlone<GetChunkQueryVariables>) {
      return this.getChunkGql.fetch({variables})
    }
    
    getChunkWatch(variables: GetChunkQueryVariables, options?: WatchQueryOptionsAlone<GetChunkQueryVariables>) {
      return this.getChunkGql.watch({variables})
    }
    
    getCollections(variables?: GetCollectionsQueryVariables, options?: QueryOptionsAlone<GetCollectionsQueryVariables>) {
      return this.getCollectionsGql.fetch({variables})
    }
    
    getCollectionsWatch(variables?: GetCollectionsQueryVariables, options?: WatchQueryOptionsAlone<GetCollectionsQueryVariables>) {
      return this.getCollectionsGql.watch({variables})
    }
    
    getCollection(variables: GetCollectionQueryVariables, options?: QueryOptionsAlone<GetCollectionQueryVariables>) {
      return this.getCollectionGql.fetch({variables})
    }
    
    getCollectionWatch(variables: GetCollectionQueryVariables, options?: WatchQueryOptionsAlone<GetCollectionQueryVariables>) {
      return this.getCollectionGql.watch({variables})
    }
    
    updateCollection(variables: UpdateCollectionMutationVariables, options?: MutationOptionsAlone<UpdateCollectionMutation, UpdateCollectionMutationVariables>) {
      return this.updateCollectionGql.mutate({variables})
    }
    
    insertCollection(variables: InsertCollectionMutationVariables, options?: MutationOptionsAlone<InsertCollectionMutation, InsertCollectionMutationVariables>) {
      return this.insertCollectionGql.mutate({variables})
    }
    
    getDefaultSystemPrompt(variables?: GetDefaultSystemPromptQueryVariables, options?: QueryOptionsAlone<GetDefaultSystemPromptQueryVariables>) {
      return this.getDefaultSystemPromptGql.fetch({variables})
    }
    
    getDefaultSystemPromptWatch(variables?: GetDefaultSystemPromptQueryVariables, options?: WatchQueryOptionsAlone<GetDefaultSystemPromptQueryVariables>) {
      return this.getDefaultSystemPromptGql.watch({variables})
    }
    
    getDocuments(variables?: GetDocumentsQueryVariables, options?: QueryOptionsAlone<GetDocumentsQueryVariables>) {
      return this.getDocumentsGql.fetch({variables})
    }
    
    getDocumentsWatch(variables?: GetDocumentsQueryVariables, options?: WatchQueryOptionsAlone<GetDocumentsQueryVariables>) {
      return this.getDocumentsGql.watch({variables})
    }
    
    getDocumentFileId(variables: GetDocumentFileIdQueryVariables, options?: QueryOptionsAlone<GetDocumentFileIdQueryVariables>) {
      return this.getDocumentFileIdGql.fetch({variables})
    }
    
    getDocumentFileIdWatch(variables: GetDocumentFileIdQueryVariables, options?: WatchQueryOptionsAlone<GetDocumentFileIdQueryVariables>) {
      return this.getDocumentFileIdGql.watch({variables})
    }
    
    updateFiles(variables?: UpdateFilesMutationVariables, options?: MutationOptionsAlone<UpdateFilesMutation, UpdateFilesMutationVariables>) {
      return this.updateFilesGql.mutate({variables})
    }
    
    getMessageAttachmentsByPk(variables: GetMessageAttachmentsByPkQueryVariables, options?: QueryOptionsAlone<GetMessageAttachmentsByPkQueryVariables>) {
      return this.getMessageAttachmentsByPkGql.fetch({variables})
    }
    
    getMessageAttachmentsByPkWatch(variables: GetMessageAttachmentsByPkQueryVariables, options?: WatchQueryOptionsAlone<GetMessageAttachmentsByPkQueryVariables>) {
      return this.getMessageAttachmentsByPkGql.watch({variables})
    }
    
    deleteMessageAttachmentByPk(variables: DeleteMessageAttachmentByPkMutationVariables, options?: MutationOptionsAlone<DeleteMessageAttachmentByPkMutation, DeleteMessageAttachmentByPkMutationVariables>) {
      return this.deleteMessageAttachmentByPkGql.mutate({variables})
    }
    
    getOrganizations(variables?: GetOrganizationsQueryVariables, options?: QueryOptionsAlone<GetOrganizationsQueryVariables>) {
      return this.getOrganizationsGql.fetch({variables})
    }
    
    getOrganizationsWatch(variables?: GetOrganizationsQueryVariables, options?: WatchQueryOptionsAlone<GetOrganizationsQueryVariables>) {
      return this.getOrganizationsGql.watch({variables})
    }
    
    getOrganization(variables: GetOrganizationQueryVariables, options?: QueryOptionsAlone<GetOrganizationQueryVariables>) {
      return this.getOrganizationGql.fetch({variables})
    }
    
    getOrganizationWatch(variables: GetOrganizationQueryVariables, options?: WatchQueryOptionsAlone<GetOrganizationQueryVariables>) {
      return this.getOrganizationGql.watch({variables})
    }
    
    updateOrganization(variables: UpdateOrganizationMutationVariables, options?: MutationOptionsAlone<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
      return this.updateOrganizationGql.mutate({variables})
    }
    
    insertOrganization(variables: InsertOrganizationMutationVariables, options?: MutationOptionsAlone<InsertOrganizationMutation, InsertOrganizationMutationVariables>) {
      return this.insertOrganizationGql.mutate({variables})
    }
    
    getUser(variables: GetUserQueryVariables, options?: QueryOptionsAlone<GetUserQueryVariables>) {
      return this.getUserGql.fetch({variables})
    }
    
    getUserWatch(variables: GetUserQueryVariables, options?: WatchQueryOptionsAlone<GetUserQueryVariables>) {
      return this.getUserGql.watch({variables})
    }
    
    updateUser(variables: UpdateUserMutationVariables, options?: MutationOptionsAlone<UpdateUserMutation, UpdateUserMutationVariables>) {
      return this.updateUserGql.mutate({variables})
    }
    
    getUsers(variables?: GetUsersQueryVariables, options?: QueryOptionsAlone<GetUsersQueryVariables>) {
      return this.getUsersGql.fetch({variables})
    }
    
    getUsersWatch(variables?: GetUsersQueryVariables, options?: WatchQueryOptionsAlone<GetUsersQueryVariables>) {
      return this.getUsersGql.watch({variables})
    }
    
    insertUser(variables: InsertUserMutationVariables, options?: MutationOptionsAlone<InsertUserMutation, InsertUserMutationVariables>) {
      return this.insertUserGql.mutate({variables})
    }
    
    updateUsers(variables: UpdateUsersMutationVariables, options?: MutationOptionsAlone<UpdateUsersMutation, UpdateUsersMutationVariables>) {
      return this.updateUsersGql.mutate({variables})
    }
  }
export type getAiModelsVariables = GetAiModelsQueryVariables;
export type getAiModels = GetAiModelsQuery;
export type getAiModels_ai_models = NonNullable<(NonNullable<GetAiModelsQuery['ai_models']>)[number]>;
export type getAiModels_ai_models_aggregate = (NonNullable<GetAiModelsQuery['ai_models_aggregate']>);
export type getAiModels_ai_models_aggregate_aggregate = (NonNullable<(NonNullable<GetAiModelsQuery['ai_models_aggregate']>)['aggregate']>);

export type getAiModelVariables = GetAiModelQueryVariables;
export type getAiModel = GetAiModelQuery;
export type getAiModel_ai_models_by_pk = (NonNullable<GetAiModelQuery['ai_models_by_pk']>);

export type insertAiModelVariables = InsertAiModelMutationVariables;
export type insertAiModel = InsertAiModelMutation;
export type insertAiModel_insert_ai_models_one = (NonNullable<InsertAiModelMutation['insert_ai_models_one']>);

export type updateAiModelVariables = UpdateAiModelMutationVariables;
export type updateAiModel = UpdateAiModelMutation;
export type updateAiModel_update_ai_models_by_pk = (NonNullable<UpdateAiModelMutation['update_ai_models_by_pk']>);

export type getChatVariables = GetChatQueryVariables;
export type getChat = GetChatQuery;
export type getChat_chats_by_pk = (NonNullable<GetChatQuery['chats_by_pk']>);
export type getChat_chats_by_pk_Messages = NonNullable<(NonNullable<(NonNullable<GetChatQuery['chats_by_pk']>)['Messages']>)[number]>;
export type getChat_chats_by_pk_Messages_Sources = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetChatQuery['chats_by_pk']>)['Messages']>)[number]>['Sources']>)[number]>;
export type getChat_chats_by_pk_Messages_Sources_Chunk = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetChatQuery['chats_by_pk']>)['Messages']>)[number]>['Sources']>)[number]>['Chunk']>);
export type getChat_chats_by_pk_Messages_Sources_Chunk_Document = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetChatQuery['chats_by_pk']>)['Messages']>)[number]>['Sources']>)[number]>['Chunk']>)['Document']>);
export type getChat_chats_by_pk_Messages_Sources_Chunk_Document_File = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetChatQuery['chats_by_pk']>)['Messages']>)[number]>['Sources']>)[number]>['Chunk']>)['Document']>)['File']>);
export type getChat_chats_by_pk_Messages_Attachments = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetChatQuery['chats_by_pk']>)['Messages']>)[number]>['Attachments']>)[number]>;
export type getChat_chats_by_pk_Messages_Attachments_File = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetChatQuery['chats_by_pk']>)['Messages']>)[number]>['Attachments']>)[number]>['File']>);
export type getChat_chats_by_pk_Collection = (NonNullable<(NonNullable<GetChatQuery['chats_by_pk']>)['Collection']>);
export type getChat_chats_by_pk_Collection_Documents = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetChatQuery['chats_by_pk']>)['Collection']>)['Documents']>)[number]>;
export type getChat_chats_by_pk_Collection_Documents_File = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetChatQuery['chats_by_pk']>)['Collection']>)['Documents']>)[number]>['File']>);

export type getChatsVariables = GetChatsQueryVariables;
export type getChats = GetChatsQuery;
export type getChats_chats = NonNullable<(NonNullable<GetChatsQuery['chats']>)[number]>;
export type getChats_chats_aggregate = (NonNullable<GetChatsQuery['chats_aggregate']>);
export type getChats_chats_aggregate_aggregate = (NonNullable<(NonNullable<GetChatsQuery['chats_aggregate']>)['aggregate']>);

export type updateChatVariables = UpdateChatMutationVariables;
export type updateChat = UpdateChatMutation;
export type updateChat_update_chats_by_pk = (NonNullable<UpdateChatMutation['update_chats_by_pk']>);

export type getChunkVariables = GetChunkQueryVariables;
export type getChunk = GetChunkQuery;
export type getChunk_chunks_by_pk = (NonNullable<GetChunkQuery['chunks_by_pk']>);
export type getChunk_chunks_by_pk_Document = (NonNullable<(NonNullable<GetChunkQuery['chunks_by_pk']>)['Document']>);
export type getChunk_chunks_by_pk_Document_File = (NonNullable<(NonNullable<(NonNullable<GetChunkQuery['chunks_by_pk']>)['Document']>)['File']>);

export type getCollectionsVariables = GetCollectionsQueryVariables;
export type getCollections = GetCollectionsQuery;
export type getCollections_collections = NonNullable<(NonNullable<GetCollectionsQuery['collections']>)[number]>;
export type getCollections_collections_Documents = NonNullable<(NonNullable<NonNullable<(NonNullable<GetCollectionsQuery['collections']>)[number]>['Documents']>)[number]>;
export type getCollections_collections_Documents_File = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GetCollectionsQuery['collections']>)[number]>['Documents']>)[number]>['File']>);
export type getCollections_collections_aggregate = (NonNullable<GetCollectionsQuery['collections_aggregate']>);
export type getCollections_collections_aggregate_aggregate = (NonNullable<(NonNullable<GetCollectionsQuery['collections_aggregate']>)['aggregate']>);

export type getCollectionVariables = GetCollectionQueryVariables;
export type getCollection = GetCollectionQuery;
export type getCollection_collections_by_pk = (NonNullable<GetCollectionQuery['collections_by_pk']>);
export type getCollection_collections_by_pk_Documents = NonNullable<(NonNullable<(NonNullable<GetCollectionQuery['collections_by_pk']>)['Documents']>)[number]>;
export type getCollection_collections_by_pk_Documents_File = (NonNullable<NonNullable<(NonNullable<(NonNullable<GetCollectionQuery['collections_by_pk']>)['Documents']>)[number]>['File']>);

export type updateCollectionVariables = UpdateCollectionMutationVariables;
export type updateCollection = UpdateCollectionMutation;
export type updateCollection_update_collections_by_pk = (NonNullable<UpdateCollectionMutation['update_collections_by_pk']>);
export type updateCollection_delete_documents = (NonNullable<UpdateCollectionMutation['delete_documents']>);
export type updateCollection_insert_documents = (NonNullable<UpdateCollectionMutation['insert_documents']>);

export type insertCollectionVariables = InsertCollectionMutationVariables;
export type insertCollection = InsertCollectionMutation;
export type insertCollection_insert_collections_one = (NonNullable<InsertCollectionMutation['insert_collections_one']>);

export type getDefaultSystemPromptVariables = GetDefaultSystemPromptQueryVariables;
export type getDefaultSystemPrompt = GetDefaultSystemPromptQuery;
export type getDefaultSystemPrompt_get_default_system_prompt = NonNullable<(NonNullable<GetDefaultSystemPromptQuery['get_default_system_prompt']>)[number]>;

export type getDocumentsVariables = GetDocumentsQueryVariables;
export type getDocuments = GetDocumentsQuery;
export type getDocuments_documents = NonNullable<(NonNullable<GetDocumentsQuery['documents']>)[number]>;
export type getDocuments_documents_aggregate = (NonNullable<GetDocumentsQuery['documents_aggregate']>);
export type getDocuments_documents_aggregate_aggregate = (NonNullable<(NonNullable<GetDocumentsQuery['documents_aggregate']>)['aggregate']>);

export type GetDocumentFileIdVariables = GetDocumentFileIdQueryVariables;
export type GetDocumentFileId = GetDocumentFileIdQuery;
export type GetDocumentFileId_documents_by_pk = (NonNullable<GetDocumentFileIdQuery['documents_by_pk']>);

export type updateFilesVariables = UpdateFilesMutationVariables;
export type updateFiles = UpdateFilesMutation;
export type updateFiles_update_files = (NonNullable<UpdateFilesMutation['update_files']>);

export type getMessageAttachmentsByPkVariables = GetMessageAttachmentsByPkQueryVariables;
export type getMessageAttachmentsByPk = GetMessageAttachmentsByPkQuery;
export type getMessageAttachmentsByPk_message_attachments_by_pk = (NonNullable<GetMessageAttachmentsByPkQuery['message_attachments_by_pk']>);
export type getMessageAttachmentsByPk_message_attachments_by_pk_File = (NonNullable<(NonNullable<GetMessageAttachmentsByPkQuery['message_attachments_by_pk']>)['File']>);

export type deleteMessageAttachmentByPkVariables = DeleteMessageAttachmentByPkMutationVariables;
export type deleteMessageAttachmentByPk = DeleteMessageAttachmentByPkMutation;
export type deleteMessageAttachmentByPk_delete_message_attachments_by_pk = (NonNullable<DeleteMessageAttachmentByPkMutation['delete_message_attachments_by_pk']>);

export type getOrganizationsVariables = GetOrganizationsQueryVariables;
export type getOrganizations = GetOrganizationsQuery;
export type getOrganizations_organizations = NonNullable<(NonNullable<GetOrganizationsQuery['organizations']>)[number]>;
export type getOrganizations_organizations_Logo = (NonNullable<NonNullable<(NonNullable<GetOrganizationsQuery['organizations']>)[number]>['Logo']>);
export type getOrganizations_organizations_Favicon = (NonNullable<NonNullable<(NonNullable<GetOrganizationsQuery['organizations']>)[number]>['Favicon']>);
export type getOrganizations_organizations_Users_aggregate = (NonNullable<NonNullable<(NonNullable<GetOrganizationsQuery['organizations']>)[number]>['Users_aggregate']>);
export type getOrganizations_organizations_Users_aggregate_aggregate = (NonNullable<(NonNullable<NonNullable<(NonNullable<GetOrganizationsQuery['organizations']>)[number]>['Users_aggregate']>)['aggregate']>);
export type getOrganizations_organizations_aggregate = (NonNullable<GetOrganizationsQuery['organizations_aggregate']>);
export type getOrganizations_organizations_aggregate_aggregate = (NonNullable<(NonNullable<GetOrganizationsQuery['organizations_aggregate']>)['aggregate']>);

export type getOrganizationVariables = GetOrganizationQueryVariables;
export type getOrganization = GetOrganizationQuery;
export type getOrganization_organizations_by_pk = (NonNullable<GetOrganizationQuery['organizations_by_pk']>);
export type getOrganization_organizations_by_pk_Logo = (NonNullable<(NonNullable<GetOrganizationQuery['organizations_by_pk']>)['Logo']>);
export type getOrganization_organizations_by_pk_Favicon = (NonNullable<(NonNullable<GetOrganizationQuery['organizations_by_pk']>)['Favicon']>);
export type getOrganization_organizations_by_pk_LargeLanguageModel = (NonNullable<(NonNullable<GetOrganizationQuery['organizations_by_pk']>)['LargeLanguageModel']>);
export type getOrganization_organizations_by_pk_EmbeddingModel = (NonNullable<(NonNullable<GetOrganizationQuery['organizations_by_pk']>)['EmbeddingModel']>);
export type getOrganization_organizations_by_pk_RerankerModel = (NonNullable<(NonNullable<GetOrganizationQuery['organizations_by_pk']>)['RerankerModel']>);

export type updateOrganizationVariables = UpdateOrganizationMutationVariables;
export type updateOrganization = UpdateOrganizationMutation;
export type updateOrganization_update_organizations_by_pk = (NonNullable<UpdateOrganizationMutation['update_organizations_by_pk']>);
export type updateOrganization_delete_files = (NonNullable<UpdateOrganizationMutation['delete_files']>);

export type insertOrganizationVariables = InsertOrganizationMutationVariables;
export type insertOrganization = InsertOrganizationMutation;
export type insertOrganization_insert_organizations_one = (NonNullable<InsertOrganizationMutation['insert_organizations_one']>);

export type getUserVariables = GetUserQueryVariables;
export type getUser = GetUserQuery;
export type getUser_users_by_pk = (NonNullable<GetUserQuery['users_by_pk']>);
export type getUser_users_by_pk_Organization = (NonNullable<(NonNullable<GetUserQuery['users_by_pk']>)['Organization']>);
export type getUser_users_by_pk_Organization_Logo = (NonNullable<(NonNullable<(NonNullable<GetUserQuery['users_by_pk']>)['Organization']>)['Logo']>);
export type getUser_users_by_pk_Organization_Favicon = (NonNullable<(NonNullable<(NonNullable<GetUserQuery['users_by_pk']>)['Organization']>)['Favicon']>);

export type updateUserVariables = UpdateUserMutationVariables;
export type updateUser = UpdateUserMutation;
export type updateUser_update_users_by_pk = (NonNullable<UpdateUserMutation['update_users_by_pk']>);

export type getUsersVariables = GetUsersQueryVariables;
export type getUsers = GetUsersQuery;
export type getUsers_users = NonNullable<(NonNullable<GetUsersQuery['users']>)[number]>;
export type getUsers_users_aggregate = (NonNullable<GetUsersQuery['users_aggregate']>);
export type getUsers_users_aggregate_aggregate = (NonNullable<(NonNullable<GetUsersQuery['users_aggregate']>)['aggregate']>);

export type insertUserVariables = InsertUserMutationVariables;
export type insertUser = InsertUserMutation;
export type insertUser_insert_users_one = (NonNullable<InsertUserMutation['insert_users_one']>);

export type updateUsersVariables = UpdateUsersMutationVariables;
export type updateUsers = UpdateUsersMutation;
export type updateUsers_update_users = (NonNullable<UpdateUsersMutation['update_users']>);
export type updateUsers_update_users_returning = NonNullable<(NonNullable<(NonNullable<UpdateUsersMutation['update_users']>)['returning']>)[number]>;
